<template>
  <b-container fluid>
  <iq-card>
      <template v-slot:headerTitle>
          <h4 class="card-title">{{ $t('externalUser.pat_reg_info_x') }}</h4>
      </template>
      <b-row>
              <b-col lg="12" sm="12" class="text-dark">
              <b-col lg="12" sm="12">{{$t('externalUser.pat_reg_info_a')}}</b-col>
              <b-col lg="12" sm="12">{{$t('externalUser.pat_reg_info_b')}}</b-col>
              <b-col lg="12" sm="12">{{$t('externalUser.pat_reg_info_d')}}</b-col>
              <b-col lg="12" sm="12">{{$t('externalUser.pat_reg_info_e')}}</b-col>
              <b-col lg="12" sm="12">{{$t('externalUser.pat_reg_info_c')}}</b-col>
              </b-col>
      </b-row>
  </iq-card>
  <iq-card>
      <template v-slot:headerTitle>
          <h4 class="card-title">{{ $t('externalUser.financial_assistance') }}</h4>
      </template>
    <b-row>
      <b-col lg="12" sm="12">
      <br>
        <iq-card>
          <template v-slot:body>
            <div style="font-size:16px;" class="bg-gray">
                <h5 class="text-dark text-center"> {{ $t('externalUser.search_receive_service') }}</h5>
            </div>
            <b-overlay :show="loading">
              <b-row>
                <b-col lg="12" sm="12">
                  <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                  <b-form  @submit.prevent="handleSubmit(register)" @reset.prevent="reset" >
                        <b-row>
                          <b-col sm="12" lg="4" xl="4">
                            <ValidationProvider name="Area Type" vid="hos_area_type_id" rules="required|min_value:1">
                                <b-form-group
                                class="row"
                                label-cols-sm="12"
                                label-for="hos_area_type_id "
                                slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                  {{$t('org_pro.area_type')}} <span class="text-danger">*</span>
                                </template>
                                <b-form-select
                                  plain
                                  v-model="patient_registration.hos_area_type_id"
                                  id="hos_area_type_id"
                                  :options="getHosAreaTypeList"
                                  @change="getAreaTypeData(patient_registration.area_type_id)"
                                  :state="errors[0] ? false : (valid ? true : null)"
                                >
                                <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                </template>
                                </b-form-select>
                                <div class="invalid-feedback">
                                  {{ errors[0] }}
                                </div>
                                </b-form-group>
                            </ValidationProvider>
                          </b-col>
                          <b-col sm="12" lg="4" xl="4">
                          <ValidationProvider name="Division" vid="hos_division_id" rules="required|min_value:1">
                              <b-form-group
                              class="row"
                              label-cols-sm="12"
                              label-for="hos_division_id "
                              slot-scope="{ valid, errors }"
                              >
                              <template v-slot:label>
                                {{$t('externalUser.division')}} <span class="text-danger">*</span>
                              </template>
                              <b-form-select
                                plain
                                v-model="patient_registration.hos_division_id"
                                id="hos_division_id"
                                :options="getHosDivisionList"
                                :state="errors[0] ? false : (valid ? true : null)"
                              >
                              <template v-slot:first>
                              <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                              </template>
                              </b-form-select>
                              <div class="invalid-feedback">
                                {{ errors[0] }}
                              </div>
                              </b-form-group>
                          </ValidationProvider>
                        </b-col>
                        <b-col sm="12" lg="4" xl="4">
                          <ValidationProvider name="District" vid="hos_district_id" rules="required|min_value:1">
                              <b-form-group
                              class="row"
                              label-cols-sm="12"
                              label-for="hos_district_id "
                              slot-scope="{ valid, errors }"
                              >
                              <template v-slot:label>
                                {{$t('org_pro_district.district')}} <span class="text-danger">*</span>
                              </template>
                              <b-form-select
                                plain
                                v-model="patient_registration.hos_district_id"
                                id="hos_district_id"
                                :options="getHosDistrictList"
                                :state="errors[0] ? false : (valid ? true : null)"
                              >
                              <template v-slot:first>
                              <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                              </template>
                              </b-form-select>
                              <div class="invalid-feedback">
                                {{ errors[0] }}
                              </div>
                              </b-form-group>
                          </ValidationProvider>
                        </b-col>
                        <b-col sm="12" lg="4" xl="4" v-if="patient_registration.hos_area_type_id > 1">
                          <ValidationProvider name="Upazila" vid="hos_upazila_id" rules="required|min_value:1">
                              <b-form-group
                              class="row"
                              label-cols-sm="12"
                              label-for="hos_upazila_id "
                              slot-scope="{ valid, errors }"
                              >
                              <template v-slot:label>
                                {{$t('org_pro_upazilla.upazilla')}} <span class="text-danger">*</span>
                              </template>
                              <b-form-select
                                plain
                                v-model="patient_registration.hos_upazila_id"
                                id="hos_upazila_id"
                                :options="getHosUpazillaList"
                                :state="errors[0] ? false : (valid ? true : null)"
                              >
                              <template v-slot:first>
                              <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                              </template>
                              </b-form-select>
                              <div class="invalid-feedback">
                                {{ errors[0] }}
                              </div>
                              </b-form-group>
                          </ValidationProvider>
                        </b-col>
                        <b-col sm="12" lg="4" xl="4" v-if="patient_registration.hos_area_type_id === 1">
                          <ValidationProvider name="City Corporation" vid="hos_city_corporation_id" rules="required|min_value:1">
                              <b-form-group
                              class="row"
                              label-cols-sm="12"
                              label-for="hos_city_corporation_id "
                              slot-scope="{ valid, errors }"
                              >
                              <template v-slot:label>
                                {{$t('org_pro.city_corporation')}} <span class="text-danger">*</span>
                              </template>
                              <b-form-select
                                plain
                                v-model="patient_registration.hos_city_corporation_id"
                                id="hos_city_corporation_id"
                                :options="getHosCityCorporationList"
                                :state="errors[0] ? false : (valid ? true : null)"
                              >
                              <template v-slot:first>
                              <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                              </template>
                              </b-form-select>
                              <div class="invalid-feedback">
                                {{ errors[0] }}
                              </div>
                              </b-form-group>
                          </ValidationProvider>
                        </b-col>
                        <b-col sm="12" lg="8" xl="8">
                          <ValidationProvider name="Hospital" vid="hospital_id" rules="required">
                              <b-form-group
                              class="row"
                              label-cols-sm="12"
                              label-for="hospital_id "
                              slot-scope="{ valid, errors }"
                              >
                              <template v-slot:label>
                                {{$t('billing_info.hospital_name')}} <span class="text-danger">*</span>
                              </template>
                              <!--<b-form-select
                                plain
                                v-model="patient_registration.hospital_id"
                                id="hospital_id"
                                :options="hosHospitalList"
                                :state="errors[0] ? false : (valid ? true : null)"
                              >
                              <template v-slot:first>
                              <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                              </template>
                              </b-form-select>-->
                              <v-select name="hospit_id"
                                v-model="patient_registration.hospit_id"
                                label="text"
                                :reduce="item => item.value"
                                :options= hosHospitalList
                                :placeholder="$t('globalTrans.select')"
                                :filter-by="myFilter"
                              />
                              <div class="invalid-feedback d-block">
                                {{ errors[0] }}
                              </div>
                              </b-form-group>
                          </ValidationProvider>
                        </b-col>
                     <!--  <b-col sm="12" lg="8" xl="8" v-if="patient_registration.hos_upazila_id > 0 && patient_registration.hos_area_type_id > 1">
                          <ValidationProvider name="Hospital" vid="hospital_id" rules="required">
                              <b-form-group
                              class="row"
                              label-cols-sm="12"
                              label-for="hospital_id "
                              slot-scope="{ valid, errors }"
                              >
                              <template v-slot:label>
                                {{$t('hospital_public_panel.hospital_x')}} <span class="text-danger">*</span>
                              </template>
                                  <v-select name="fiscal_year_id"
                                    v-model="patient_registration.hospit_id"
                                    label="text"
                                    :reduce="item => item.value"
                                    :options= hosHospitalList
                                    :placeholder="$t('globalTrans.select')"
                                    :filter-by="myFilter"
                                  />
                                <div class="invalid-feedback d-block">
                                {{ errors[0] }}
                              </div>
                              </b-form-group>
                          </ValidationProvider>
                        </b-col>-->
                      </b-row>
                      <b-row>
                        <b-col lg="3" sm="3" :hidden="$store.state.Auth.isLoggedIn === false ? true : false">
                        <ValidationProvider name="Hospital Reg Form No" vid="form_no" rules="required">
                          <b-form-group
                            class="row"
                            label-cols-sm="12"
                            label-for="form_no"
                            slot-scope="{ valid, errors }"
                            >
                            <template v-slot:label>
                              {{ $t('hospital_information.form_no')}} <span class="text-danger">*</span>
                            </template>
                            <b-form-input
                              id="form_no"
                              v-model="patient_registration.form_no"
                              disabled
                              :state="errors[0] ? false : (valid ? true : null)"
                              ></b-form-input>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </b-form-group>
                        </ValidationProvider>
                        </b-col>
                      <b-col lg="3" sm="3">
                      <ValidationProvider name="Date" vid="reg_date" rules="required">
                        <b-form-group
                          class="row"
                          label-cols-sm="12"
                          label-for="reg_date"
                          slot-scope="{ valid, errors }"
                          >
                          <template v-slot:label>
                            {{ $t('globalTrans.date')}} <span class="text-danger">*</span>
                          </template>
                          <b-form-input
                            id="reg_date"
                            v-model="patient_registration.reg_date"
                            disabled
                            :state="errors[0] ? false : (valid ? true : null)"
                            ></b-form-input>
                          <div class="invalid-feedback">
                            {{ errors[0] }}
                          </div>
                        </b-form-group>
                      </ValidationProvider>
                      </b-col>
                      </b-row>
                      <div style="font-size:16px; margin-bottom:5px;" class="bg-gray">
                          <h5 class="text-dark text-center mb-2"> {{ $t('externalUser.pat_per_info') }}</h5>
                      </div>
                      <b-row>
                      <b-col xl="12" lg="12" sm="12">
                                  <ValidationProvider name="mob_no_type" vid="mob_no_type" rules="required">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="12"
                                        label-for="mob_no_type"
                                        slot-scope="{ valid, errors }"
                                        >
                                        <template v-slot:label>
                                          {{ $t('hospital_information.applicant')}}<span class="text-danger">*</span>
                                        </template>
                                    <b-form-radio-group
                                    id="radio-group-2"
                                    v-model="patient_registration.mob_no_type"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    name="mob_no_type"
                                    >
                          <b-form-radio :selected="patient_registration.mob_no_type === 1 ? true : false" name="mobNoType" value="1">{{$t('hospital_information.patient_self')}}</b-form-radio><br>
                          <b-form-radio :selected="patient_registration.mob_no_type === 2 ? true : false" name="mobNoType" value="2">{{$t('hospital_information.guardians_care')}}</b-form-radio>
                                          <div class="invalid-feedback">
                                          {{ errors[0] }}
                                        </div>
                                    </b-form-radio-group>
                                    </b-form-group>
                                  </ValidationProvider>
                      </b-col>
                      <b-col xl="12" lg="12" sm="12">
                        <ValidationProvider name="NID/BRS" vid="nid_or_brs" rules="required|min_value:1">
                            <b-form-group
                                class="row"
                                label-cols-sm="12"
                                label-for="nid_or_brs"
                                slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                    {{ $t('externalUser.nidBrs')}} <span class="text-danger">*</span>
                                </template>
                                <b-form-radio-group
                                    :disabled="$route.query.id ? true : false"
                                    v-model="patient_registration.nid_or_brs"
                                    :options="getNidBrsList"
                                    value-field="value"
                                    text-field="text"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                ></b-form-radio-group>
                                <div class="invalid-feedback d-block">
                                {{ errors[0] }}
                                </div>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col xl="12" lg="12" sm="12">
                    </b-col>
                    <b-col xl="3" lg="3" sm="3" v-if="patient_registration.nid_or_brs == 1">
                        <ValidationProvider name="NID No" vid="nid" rules="required|numeric|max:24">
                            <b-form-group
                                class="row"
                                label-cols-sm="12"
                                label-for="nid"
                                slot-scope="{ valid, errors }"
                            >
                                <template v-slot:label>
                                    {{$t('externalUser.nid') + ' (' + $t('externalUser.en') + ')' }} <span class="text-danger">*</span>
                                </template>
                                <b-form-input
                                    class="form-control"
                                    v-model="patient_registration.nid"
                                    id="nid"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    :disabled ="nidButtonDisabled"
                                ></b-form-input>
                                <div class="invalid-feedback">
                                    {{ errors[0] }}
                                </div>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col xl="3" lg="3" sm="3"  v-if="patient_registration.nid_or_brs == 2">
                              <ValidationProvider name="BRS No" vid="brs_no" rules="required|max:24|numeric">
                                  <b-form-group
                                      class="row"
                                      label-cols-sm="12"
                                      label-for="brs_no"
                                      slot-scope="{ valid, errors }"
                                  >
                                      <template v-slot:label>
                                          {{ $t('externalUser.brs_no') + ' (' + $t('externalUser.en') + ')' }} <span class="text-danger">*</span>
                                      </template>
                                      <b-form-input
                                          class="form-control"
                                          v-model="patient_registration.brs_no"
                                          id="brs_no"
                                          :state="errors[0] ? false : (valid ? true : null)"
                                      ></b-form-input>
                                      <div class="invalid-feedback">
                                          {{ errors[0] }}
                                      </div>
                                  </b-form-group>
                              </ValidationProvider>
                          </b-col>
                          <b-col xl="3" lg="3" sm="3" >
                              <ValidationProvider name="Date of Birth" vid="dob" rules="required">
                                  <b-form-group
                                      class="row"
                                      label-cols-sm="12"
                                      label-for="dob"
                                      slot-scope="{ valid, errors }"
                                  >
                                  <template v-slot:label>
                                      {{$t('externalUser.dob')}} <span class="text-danger">*</span>
                                  </template>
                                  <div class="input-group">
                                      <slot v-if="!nidButtonDisabled">
                                          <flat-pickr
                                              :config="{ maxDate: 'today' }"
                                              class="form-control disabled"
                                              v-model="patient_registration.dob"
                                              id="  "
                                              placeholder="Select Date"
                                              :state="errors[0] ? false : (valid ? true : null)"
                                          >
                                          </flat-pickr>
                                      </slot>
                                      <slot v-else>
                                          <b-form-input
                                              class="form-control"
                                              v-model="patient_registration.dob"
                                              id="dob"
                                              :state="errors[0] ? false : (valid ? true : null)"
                                              readonly
                                          ></b-form-input>
                                      </slot>
<!-- <button v-if="patient_registration.nid_or_brs === 1" type="button" :disabled ="nidButtonDisabled" @click="nidVerify()" style="border-radius: 0px !important" class="btn btn-outline-primary">{{ nid_verify_check === 1 ? $t('globalTrans.verify') : $t('globalTrans.verified') }}</button> -->
                                  </div>
                                  <div class="invalid-feedback d-block">
                                      {{ errors[0] }}
                                  </div>
                                  </b-form-group>
                              </ValidationProvider>
                          </b-col>
                      <b-col lg="3" sm="3">
                      <ValidationProvider name="Patient Name (Bn)" vid="patient_name_bn" rules="required">
                        <b-form-group
                          class="row"
                          label-cols-sm="12"
                          label-for="patient_name_bn"
                          slot-scope="{ valid, errors }"
                          >
                          <template v-slot:label>
                            {{ $t('hospital_information.patient_name_bn')}} <span class="text-danger">*</span>
                          </template>
                          <b-form-input
                            id="patient_name_bn"
                            v-model="patient_registration.patient_name_bn"
                            :state="errors[0] ? false : (valid ? true : null)"
                            ></b-form-input>
  <!-- :disabled ="patient_registration.nid_or_brs === 1 ? true : false" -->
                          <div class="invalid-feedback">
                            {{ errors[0] }}
                          </div>
                        </b-form-group>
                      </ValidationProvider>
                      </b-col>
                      <b-col lg="3" sm="3">
                      <ValidationProvider name="Patient Name" vid="patient_name" rules="required">
                        <b-form-group
                          class="row"
                          label-cols-sm="12"
                          label-for="patient_name"
                          slot-scope="{ valid, errors }"
                          >
                          <template v-slot:label>
                            {{ $t('hospital_information.patient_name_en')}} <span class="text-danger">*</span>
                          </template>
                          <b-form-input
                            id="patient_name"
                            v-model="patient_registration.patient_name"
                            :state="errors[0] ? false : (valid ? true : null)"
                            ></b-form-input>
  <!-- :disabled ="patient_registration.nid_or_brs === 1 ? true : false" -->
                            <div class="invalid-feedback">
                            {{ errors[0] }}
                          </div>
                        </b-form-group>
                      </ValidationProvider>
                      </b-col>
      <!-- <b-col lg="3" sm="3" :hidden="patient_registration.nid_or_brs === 1 ? true : false"> -->
                      <b-col lg="3" sm="3" >
                      <ValidationProvider name="Father (Bn)" vid="father_name_bn" rules="required">
                        <b-form-group
                          class="row"
                          label-cols-sm="12"
                          label-for="father_name_bn"
                          slot-scope="{ valid, errors }"
                          >
                          <template v-slot:label>
                            {{ $t('globalTrans.father_name_bn')}} <span class="text-danger">*</span>
                          </template>
                          <b-form-input
                            id="father_husband_bn"
                            v-model="patient_registration.father_name_bn"
                            :state="errors[0] ? false : (valid ? true : null)"
                            ></b-form-input>
      <!-- :disabled ="patient_registration.nid_or_brs === 1 ? true : false" -->
                          <div class="invalid-feedback">
                            {{ errors[0] }}
                          </div>
                        </b-form-group>
                      </ValidationProvider>
                      </b-col>
                      <b-col lg="3" sm="3">
                      <ValidationProvider name="Father (En)" vid="father_name_en" rules="required">
                        <b-form-group
                          class="row"
                          label-cols-sm="12"
                          label-for="father_name_en"
                          slot-scope="{ valid, errors }"
                          >
                          <template v-slot:label>
                            {{ $t('globalTrans.father_name_en')}} <span class="text-danger">*</span>
                          </template>
                          <b-form-input
                            id="father_name_en"
                            v-model="patient_registration.father_name"
                            :state="errors[0] ? false : (valid ? true : null)"
                            ></b-form-input>
                          <div class="invalid-feedback">
                            {{ errors[0] }}
                          </div>
                        </b-form-group>
                      </ValidationProvider>
                      </b-col>
  <!-- <b-col lg="3" sm="3" :hidden="patient_registration.nid_or_brs === 1 ? true : false"> -->
                      <b-col lg="3" sm="3" >
                      <ValidationProvider name="Mother Name BN" vid="mother_name_bn" rules="required">
                        <b-form-group
                          class="row"
                          label-cols-sm="12"
                          label-for="mother_name_bn"
                          slot-scope="{ valid, errors }"
                          >
                          <template v-slot:label>
                            {{ $t('hospital_information.mother_name_bn')}} <span class="text-danger">*</span>
                          </template>
                          <b-form-input
                            id="mother_name_bn"
                            v-model="patient_registration.mother_name_bn"
                            :state="errors[0] ? false : (valid ? true : null)"
                            ></b-form-input>
  <!-- :disabled ="patient_registration.nid_or_brs === 1 ? true : false" -->
                          <div class="invalid-feedback">
                            {{ errors[0] }}
                          </div>
                        </b-form-group>
                      </ValidationProvider>
                      </b-col>
                      <b-col lg="3" sm="3">
                      <ValidationProvider name="Mother Name" vid="mother_name" rules="required">
                        <b-form-group
                          class="row"
                          label-cols-sm="12"
                          label-for="mother_name"
                          slot-scope="{ valid, errors }"
                          >
                          <template v-slot:label>
                            {{ $t('hospital_information.mother_name_en')}} <span class="text-danger">*</span>
                          </template>
                          <b-form-input
                            id="mother_name"
                            v-model="patient_registration.mother_name"
                            :state="errors[0] ? false : (valid ? true : null)"
                            ></b-form-input>
                          <div class="invalid-feedback">
                            {{ errors[0] }}
                          </div>
                        </b-form-group>
                      </ValidationProvider>
                      </b-col>
                      <b-col lg="3" sm="3">
                      <ValidationProvider name="Husband Name BN" vid="husband_name_bn">
                        <b-form-group
                          class="row"
                          label-cols-sm="12"
                          label-for="husband_name_bn"
                          slot-scope="{ valid, errors }"
                          >
                          <template v-slot:label>
                            {{ $t('hospital_information.husband_name')}} {{ $t('hospital_information.bn')}}
                          </template>
                          <b-form-input
                            id="husband_name_bn"
                            v-model="patient_registration.husband_name_bn"
                            :state="errors[0] ? false : (valid ? true : null)"
                            ></b-form-input>
                          <div class="invalid-feedback">
                            {{ errors[0] }}
                          </div>
                        </b-form-group>
                      </ValidationProvider>
                      </b-col>
                      <b-col lg="3" sm="3">
                      <ValidationProvider name="Husband Name" vid="husband_name">
                        <b-form-group
                          class="row"
                          label-cols-sm="12"
                          label-for="husband_name"
                          slot-scope="{ valid, errors }"
                          >
                          <template v-slot:label>
                            {{ $t('hospital_information.husband_name')}} {{ $t('hospital_information.en')}}
                          </template>
                          <b-form-input
                            id="husband_name"
                            v-model="patient_registration.husband_name_en"
                            :state="errors[0] ? false : (valid ? true : null)"
                            ></b-form-input>
                          <div class="invalid-feedback">
                            {{ errors[0] }}
                          </div>
                        </b-form-group>
                      </ValidationProvider>
                      </b-col>
                      <b-col lg="3" sm="3">
                      <ValidationProvider name="Phone No" vid="phone_no" rules="required|max:11|min:11">
                        <b-form-group
                          class="row"
                          label-cols-sm="12"
                          label-for="phone_no"
                          slot-scope="{ valid, errors }"
                          >
                          <template v-slot:label>
                            {{ $t('globalTrans.mob_no')}} <span class="text-danger">*</span>
                          </template>
                          <b-form-input
                          type="number"
                            id="phone_no"
                            v-model="patient_registration.phone_no"
                            :state="errors[0] ? false : (valid ? true : null)"
                            ></b-form-input>
                          <div class="invalid-feedback">
                            {{ errors[0] }}
                          </div>
                        </b-form-group>
                      </ValidationProvider>
                      </b-col>
                      <b-col lg="3" sm="3">
                      <ValidationProvider name="Age" vid="age" rules="required">
                        <b-form-group
                          class="row"
                          label-cols-sm="12"
                          label-for="age"
                          slot-scope="{ valid, errors }"
                          >
                          <template v-slot:label>
                            {{ $t('hospital_information.age')}} <span class="text-danger">*</span>
                          </template>
                          <b-form-input
                          type="number"
                            id="age"
                            v-model="patient_registration.age"
                            :state="errors[0] ? false : (valid ? true : null)"
                            ></b-form-input>
                          <div class="invalid-feedback">
                            {{ errors[0] }}
                          </div>
                        </b-form-group>
                      </ValidationProvider>
                      </b-col>
                      <b-col lg="3" sm="3">
                      <ValidationProvider name="Gender" vid="gender_id" rules="required|min_value:1">
                        <b-form-group
                          class="row"
                          label-cols-sm="12"
                          label-for="gender_id"
                          slot-scope="{ valid, errors }"
                          >
                          <template v-slot:label>
                            {{ $t('hospital_information.gender')}} <span class="text-danger">*</span>
                          </template>
                          <b-form-select
                                plain
                                v-model="patient_registration.gender_id"
                                :options="genderList"
                                id="district_id"
                                :state="errors[0] ? false : (valid ? true : null)"
                                >
                            <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                            </b-form-select>
                          <div class="invalid-feedback">
                            {{ errors[0] }}
                          </div>
                        </b-form-group>
                      </ValidationProvider>
                      </b-col>
                      <b-col lg="3" sm="3">
                        <ValidationProvider name="Occupation" vid="occupation_id" rules="required">
                          <b-form-group
                            class="row"
                            label-cols-sm="12"
                            label-for="occupation_id"
                            slot-scope="{ valid, errors }"
                            >
                            <template v-slot:label>
                              {{ $t('globalTrans.occupation')}} <span class="text-danger">*</span>
                            </template>
                            <b-form-select
                                  plain
                                  v-model="patient_registration.occupation_id"
                                  :options="subOccupationList"
                                  id="occupation_id"
                                  :state="errors[0] ? false : (valid ? true : null)"
                                  >
                              <template v-slot:first>
                                  <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                              </template>
                              </b-form-select>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </b-form-group>
                        </ValidationProvider>
                        </b-col>
                      <b-col lg="3" sm="3" v-if="patient_registration.occupation_id == 12">
                      <ValidationProvider name="Occupation (Bn)" vid="occupation_bn" :rules="patient_registration.occupation_id == 12 ? 'required' : ''">
                        <b-form-group
                          class="row"
                          label-cols-sm="12"
                          label-for="occupation_bn"
                          slot-scope="{ valid, errors }"
                          >
                          <template v-slot:label>
                            {{ $t('hospital_information.occupation_bnn')}}<span class="text-danger">*</span>
                          </template>
                          <b-form-input
                            id="occupation_bn"
                            v-model="patient_registration.occupation_bn"
                            :state="errors[0] ? false : (valid ? true : null)"
                            ></b-form-input>
                          <div class="invalid-feedback">
                            {{ errors[0] }}
                          </div>
                        </b-form-group>
                      </ValidationProvider>
                      </b-col>
                      <b-col lg="3" sm="3" v-if="patient_registration.occupation_id == 12">
                      <ValidationProvider name="Occupation" :rules="patient_registration.occupation_id == 12 ? 'required' : ''">
                        <b-form-group
                          class="row"
                          label-cols-sm="12"
                          label-for="occupation"
                          slot-scope="{ valid, errors }"
                          >
                          <template v-slot:label>
                            {{ $t('hospital_information.occupation_enn')}}<span class="text-danger">*</span>
                          </template>
                          <b-form-input
                            id="occupation"
                            v-model="patient_registration.occupation"
                            :state="errors[0] ? false : (valid ? true : null)"
                            ></b-form-input>
                          <div class="invalid-feedback">
                            {{ errors[0] }}
                          </div>
                        </b-form-group>
                      </ValidationProvider>
                      </b-col>
                      <b-col lg="3" sm="3">
                      <ValidationProvider name="monthly_income" vid="monthly_income" rules="required">
                        <b-form-group
                          class="row"
                          label-cols-sm="12"
                          label-for="monthly_income"
                          slot-scope="{ valid, errors }"
                          >
                          <template v-slot:label>
                            {{ $t('hospital_information.monthly_income')}} <span class="text-danger">*</span>
                          </template>
                          <b-form-input
                          type="number"
                            id="monthly_income"
                            v-model="patient_registration.monthly_income"
                            :state="errors[0] ? false : (valid ? true : null)"
                            ></b-form-input>
                          <div class="invalid-feedback">
                            {{ errors[0] }}
                          </div>
                        </b-form-group>
                      </ValidationProvider>
                      </b-col>
                      </b-row>
                      <b-row>
                      <b-col lg="12" sm="12">
                      <ValidationProvider name="is_freedom_figter" vid="is_freedom_figter" rules="required">
                        <b-form-group
                            class="row"
                            label-cols-sm="12"
                            label-for="is_freedom_figter"
                            slot-scope="{ valid, errors }"
                            >
                            <template v-slot:label>
                              {{ $t('externalUser.patient_type')}} <span class="text-danger">*</span>
                            </template>
                        <b-form-radio-group
                        id="radio-group-2"
                        v-model="patient_registration.pat_type"
                        name="is_freedom_figter"
                        >
    <b-form-radio v-model="selected" :selected="patient_registration.is_freedom_figter === 1 ? true : false" name="some-radios" value="1">{{$t('hospital_information.freedom_figter')}}</b-form-radio>
    <b-form-radio v-model="selected" :selected="patient_registration.is_disable === 1 ? true : false" name="some-radios" value="2">{{$t('hospital_information.disable')}}</b-form-radio>
    <b-form-radio v-model="selected" :selected="patient_registration.is_underprivileged === 1 ? true : false" name="some-radios" value="3">{{$t('hospital_information.underprivileged_new')}}</b-form-radio>
    <!--<b-form-radio hidden v-model="selected" :selected="patient_registration.is_lost_person === 1 ? false : false" name="some-radios" value="4">{{$t('hospital_information.lost_person')}}</b-form-radio>-->
    <b-form-radio v-model="selected" :selected="patient_registration.other === 1 ? true : false" name="some-radios" value="5">{{$t('hospital_information.common')}}</b-form-radio>
                              <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                        </b-form-radio-group>
                        </b-form-group>
                      </ValidationProvider>
                      </b-col>
                      </b-row>
                      <b-row>
                      <b-col lg="3" sm="3">
                      <ValidationProvider name="Guardian Name (Bn)" vid="guardian_name_bn" rules="required">
                        <b-form-group
                          class="row"
                          label-cols-sm="12"
                          label-for="guardian_name"
                          slot-scope="{ valid, errors }"
                          >
                          <template v-slot:label>
                            {{ $t('hospital_information.guardian_name_bn')}} <span class="text-danger">*</span>
                          </template>
                          <b-form-input
                            id="guardian_name_bn"
                            v-model="patient_registration.guardian_name_bn"
                            :state="errors[0] ? false : (valid ? true : null)"
                            ></b-form-input>
                          <div class="invalid-feedback">
                            {{ errors[0] }}
                          </div>
                        </b-form-group>
                      </ValidationProvider>
                      </b-col>
                      <b-col lg="3" sm="3">
                      <ValidationProvider name="Guardian Name" vid="guardian_name" rules="required">
                        <b-form-group
                          class="row"
                          label-cols-sm="12"
                          label-for="guardian_name"
                          slot-scope="{ valid, errors }"
                          >
                          <template v-slot:label>
                            {{ $t('hospital_information.guardian_name_en')}} <span class="text-danger">*</span>
                          </template>
                          <b-form-input
                            id="guardian_name"
                            v-model="patient_registration.guardian_name"
                            :state="errors[0] ? false : (valid ? true : null)"
                            ></b-form-input>
                          <div class="invalid-feedback">
                            {{ errors[0] }}
                          </div>
                        </b-form-group>
                      </ValidationProvider>
                      </b-col>
                    <b-col lg="3" sm="3" >
                      <ValidationProvider name="Guardian Mobile No" vid="guardian_mobile_no" rules="required|max:11|min:11">
                        <b-form-group
                          class="row"
                          label-cols-sm="12"
                          label-for="guardian_mobile_no"
                          slot-scope="{ valid, errors }"
                          >
                          <template v-slot:label>
                          {{ $t('hospital_information.guardian_n') }} {{ $t('hospital_information.guardian_mobile')}} <span class="text-danger">*</span>
                          </template>
                          <b-form-input
                          type="number"
                            id="guardian_mobile_no"
                            v-model="patient_registration.guardian_mobile_no"
                            :state="errors[0] ? false : (valid ? true : null)"
                            ></b-form-input>
                          <div class="invalid-feedback">
                            {{ errors[0] }}
                          </div>
                        </b-form-group>
                      </ValidationProvider>
                      </b-col>
                      </b-row>
                      <iq-card>
                          <div class="card-address-header iq-card-header d-flex">
                              <h5 class="card-title">{{ $t('externalUser.present_address') }}</h5>
                          </div>
                          <div class="card-body iq-card-body card-address">
                          <b-container fluid bg-variant="primary" class="border border-success"><br>
                            <b-row>
                              <b-col lg="3" sm="3">
                                  <ValidationProvider name="Area Type" vid="pre_area_type_id"  rules="required|min_value:1">
                                      <b-form-group
                                          class="row"
                                          label-cols-sm="12"
                                          label-for="pre_area_type_id "
                                          slot-scope="{ valid, errors }"
                                          >
                                          <template v-slot:label>
                                              {{$t('org_pro.area_type')}} <span class="text-danger">*</span>
                                          </template>
                                          <b-form-select
                                          plain
                                          v-model="patient_registration.area_type_id"
                                          id="pre_area_type_id"
                                          :options="getAreaTypeList"
                                          @change="getAreaTypeData(patient_registration.area_type_id)"
                                          :state="errors[0] ? false : (valid ? true : null)"
                                          >
                                          <template v-slot:first>
                                              <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                          </template>
                                          </b-form-select>
                                          <div class="invalid-feedback">
                                          {{ errors[0] }}
                                          </div>
                                      </b-form-group>
                                  </ValidationProvider>
                              </b-col>
                              <b-col lg="3" sm="3">
                                  <ValidationProvider name="Division" vid="pre_division_id"  rules="required|min_value:1">
                                      <b-form-group
                                          class="row"
                                          label-cols-sm="12"
                                          label-for="pre_division_id"
                                          slot-scope="{ valid, errors }"
                                          >
                                          <template v-slot:label>
                                          {{ $t('org_pro_division.division')}} <span class="text-danger">*</span>
                                          </template>
                                          <b-form-select
                                          plain
                                          v-model="patient_registration.division_id"
                                          :options="divisionList"
                                          id="pre_division_id"
                                          :state="errors[0] ? false : (valid ? true : null)"
                                          >
                                          <template v-slot:first>
                                              <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                          </template>
                                          </b-form-select>
                                          <div class="invalid-feedback">
                                          {{ errors[0] }}
                                          </div>
                                      </b-form-group>
                                  </ValidationProvider>
                              </b-col>
                              <b-col lg="3" sm="3">
                                  <ValidationProvider name="District" vid="pre_district_id"  rules="required|min_value:1">
                                      <b-form-group
                                          class="row"
                                          label-cols-sm="12"
                                          label-for="pre_district_id"
                                          slot-scope="{ valid, errors }"
                                          >
                                          <template v-slot:label>
                                          {{ $t('org_pro_district.district')}} <span class="text-danger">*</span>
                                          </template>
                                          <b-form-select
                                          plain
                                          v-model="patient_registration.district_id"
                                          :options="districtList"
                                          id="pre_district_id"
                                          :state="errors[0] ? false : (valid ? true : null)"
                                          >
                                          <template v-slot:first>
                                              <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                          </template>
                                          </b-form-select>
                                          <div class="invalid-feedback">
                                          {{ errors[0] }}
                                          </div>
                                      </b-form-group>
                                  </ValidationProvider>
                              </b-col>
                            </b-row>
                            <b-row>
                              <b-col lg="3" sm="3" v-show="PauroshobaItemShow || UnionItemShow">
                                    <ValidationProvider name="Upazila" vid="pre_upazila_id" v-if="PauroshobaItemShow || UnionItemShow">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="12"
                                            label-for="pre_upazila_id"
                                            slot-scope="{ valid, errors }"
                                            >
                                            <template v-slot:label>
                                            {{ $t('org_pro_upazilla.upazilla')}} <span class="text-danger">*</span>
                                            </template>
                                            <b-form-select
                                            plain
                                            v-model="patient_registration.upazilla_id"
                                            :options="upazilaList"
                                            id="pre_upazila_id"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            >
                                            <template v-slot:first>
                                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                            </template>
                                            </b-form-select>
                                            <div class="invalid-feedback">
                                            {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="3" sm="3" v-show="UnionItemShow" >
                                    <ValidationProvider name="Union" vid="pre_union_id" v-if="UnionItemShow">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="12"
                                            label-for="pre_union_id"
                                            slot-scope="{ valid, errors }"
                                            >
                                            <template v-slot:label>
                                            {{ $t('org_pro_union.union')}} <span class="text-danger">*</span>
                                            </template>
                                            <b-form-select
                                            plain
                                            v-model="patient_registration.union_id"
                                            :options="unionList"
                                            id="pre_union_id"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            >
                                            <template v-slot:first>
                                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                            </template>
                                            </b-form-select>
                                            <div class="invalid-feedback">
                                            {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="3" sm="3" v-show="CityCorpItemShow" >
                                    <ValidationProvider name="City Corporation" vid="pre_city_corporation_id" v-if="CityCorpItemShow">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="12"
                                            label-for="pre_city_corporation_id"
                                            slot-scope="{ valid, errors }"
                                            >
                                            <template v-slot:label>
                                                {{ $t('org_pro.city_corporation') }} <span class="text-danger">*</span>
                                            </template>
                                            <b-form-select
                                            plain
                                            v-model="patient_registration.city_corporation_id"
                                            :options="cityCorporationList"
                                            id="pre_city_corporation_id"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            >
                                            <template v-slot:first>
                                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                            </template>
                                            </b-form-select>
                                            <div class="invalid-feedback">
                                            {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="3" sm="3" v-show="PauroshobaItemShow" >
                                    <ValidationProvider name="Municipality" vid="pre_pauroshoba_id">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="12"
                                            label-for="pre_pauroshoba_id"
                                            slot-scope="{ valid, errors }"
                                            >
                                            <template v-slot:label>
                                                {{ $t('org_pro.pauroshoba') }} <span class="text-danger">*</span>
                                            </template>
                                            <b-form-select
                                            plain
                                            v-model="patient_registration.pauroshoba_id"
                                            :options="pauroshobaList"
                                            id="pre_pauroshoba_id"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            >
                                            <template v-slot:first>
                                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                            </template>
                                            </b-form-select>
                                            <div class="invalid-feedback">
                                            {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="3" sm="3" v-show="ItemShow">
                                    <ValidationProvider name="Ward" vid="pre_ward_id">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="12"
                                            label-for="pre_ward_id"
                                            slot-scope="{ valid, errors }"
                                            >
                                            <template v-slot:label>
                                                {{ $t('org_pro.ward') }}
                                            </template>
                                            <b-form-select
                                            plain
                                            v-model="patient_registration.ward_id"
                                            :options="wardList"
                                            id="pre_ward_id"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            >
                                            <template v-slot:first>
                                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                            </template>
                                            </b-form-select>
                                            <div class="invalid-feedback">
                                            {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                            </b-row>
                            <b-row>
                              <b-col lg="6" sm="6">
                              <ValidationProvider name="Address (Bn)" vid="pre_address_bn" rules="required">
                                <b-form-group
                                  class="row"
                                  label-cols-sm="12"
                                  label-for="pre_address_bn"
                                  slot-scope="{ valid, errors }"
                                  >
                                  <template v-slot:label>
                                    {{ $t('hospital_information.address_bn')}} <span class="text-danger">*</span>
                                  </template>
                                  <b-form-textarea
                                    id="pre_address_bn"
                                    v-model="patient_registration.address_bn"
                                    rows = "4"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-textarea>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                </b-form-group>
                              </ValidationProvider>
                              </b-col>
                              <b-col lg="6" sm="6">
                              <ValidationProvider name="Address" vid="pre_address" rules="required">
                                <b-form-group
                                  class="row"
                                  label-cols-sm="12"
                                  label-for="pre_address"
                                  slot-scope="{ valid, errors }"
                                  >
                                  <template v-slot:label>
                                    {{ $t('hospital_information.address_en')}} <span class="text-danger">*</span>
                                  </template>
                                  <b-form-textarea
                                    id="pre_address"
                                    v-model="patient_registration.address"
                                    rows = "4"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-textarea>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                </b-form-group>
                              </ValidationProvider>
                              </b-col>
                            </b-row>
                          </b-container>
                          </div>
                      </iq-card>
                      <br>
                      <iq-card>
                          <div class="card-address-header iq-card-header d-flex">
                              <h5 class="card-title">{{ $t('externalUser.permanent_address') }}</h5>
                          </div>
                          <div class="card-body iq-card-body card-address">
                          <b-container fluid bg-variant="primary" class="border border-success"><br>
                            <b-row>
                              <b-col lg="12" sm="12">
                                  <b-form-checkbox
                                  id="checkbox-1"
                                  v-model="sameCheckVal"
                                  name="checkbox-1"
                                  value="1"
                                  @change="sameAs()"
                                  >
                                  {{ $t('externalUser.same_as_pre_address') }}
                                  </b-form-checkbox>
                              </b-col>
                              <b-col lg="3" sm="3">
                                  <ValidationProvider name="Area Type" vid="permanent_area_type_id"  rules="required|min_value:1">
                                      <b-form-group
                                          class="row"
                                          label-cols-sm="12"
                                          label-for="permanent_area_type_id "
                                          slot-scope="{ valid, errors }"
                                          >
                                          <template v-slot:label>
                                              {{$t('org_pro.area_type')}} <span class="text-danger">*</span>
                                          </template>
                                          <b-form-select
                                          plain
                                          v-model="patient_registration.permanent_area_type_id"
                                          id="permanent_area_type_id"
                                          :options="getAreaTypeList"
                                          :state="errors[0] ? false : (valid ? true : null)"
                                          >
                                          <template v-slot:first>
                                              <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                          </template>
                                          </b-form-select>
                                          <div class="invalid-feedback">
                                          {{ errors[0] }}
                                          </div>
                                      </b-form-group>
                                  </ValidationProvider>
                              </b-col>
                              <b-col lg="3" sm="3">
                                  <ValidationProvider name="Division" vid="permanent_division_id"  rules="required|min_value:1">
                                      <b-form-group
                                          class="row"
                                          label-cols-sm="12"
                                          label-for="permanent_division_id"
                                          slot-scope="{ valid, errors }"
                                          >
                                          <template v-slot:label>
                                          {{ $t('org_pro_division.division')}} <span class="text-danger">*</span>
                                          </template>
                                          <b-form-select
                                          plain
                                          v-model="patient_registration.permanent_division_id"
                                          :options="divisionList"
                                          id="permanent_division_id"
                                          :state="errors[0] ? false : (valid ? true : null)"
                                          >
                                          <template v-slot:first>
                                              <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                          </template>
                                          </b-form-select>
                                          <div class="invalid-feedback">
                                          {{ errors[0] }}
                                          </div>
                                      </b-form-group>
                                  </ValidationProvider>
                              </b-col>
                              <b-col lg="3" sm="3">
                                  <ValidationProvider name="District" vid="permanent_district_id"  rules="required|min_value:1">
                                      <b-form-group
                                          class="row"
                                          label-cols-sm="12"
                                          label-for="permanent_district_id"
                                          slot-scope="{ valid, errors }"
                                          >
                                          <template v-slot:label>
                                          {{ $t('org_pro_district.district')}} <span class="text-danger">*</span>
                                          </template>
                                          <b-form-select
                                          plain
                                          v-model="patient_registration.permanent_district_id"
                                          :options="districtPermaList"
                                          id="permanent_district_id"
                                          :state="errors[0] ? false : (valid ? true : null)"
                                          >
                                          <template v-slot:first>
                                              <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                          </template>
                                          </b-form-select>
                                          <div class="invalid-feedback">
                                          {{ errors[0] }}
                                          </div>
                                      </b-form-group>
                                  </ValidationProvider>
                              </b-col>
                            </b-row>
                            <b-row>
                              <b-col lg="3" sm="3" v-if="patient_registration.permanent_area_type_id > 1">
                                    <ValidationProvider name="Upazila" vid="permanent_upazilla_id">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="12"
                                            label-for="permanent_upazilla_id"
                                            slot-scope="{ valid, errors }"
                                            >
                                            <template v-slot:label>
                                            {{ $t('org_pro_upazilla.upazilla')}} <span class="text-danger">*</span>
                                            </template>
                                            <b-form-select
                                            plain
                                            v-model="patient_registration.permanent_upazilla_id"
                                            :options="upazillaPermaList"
                                            id="permanent_upazilla_id"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            >
                                            <template v-slot:first>
                                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                            </template>
                                            </b-form-select>
                                            <div class="invalid-feedback">
                                            {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="3" sm="3" v-if="patient_registration.permanent_area_type_id === 3">
                                    <ValidationProvider name="Union" vid="permanent_union_id">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="12"
                                            label-for="permanent_union_id"
                                            slot-scope="{ valid, errors }"
                                            >
                                            <template v-slot:label>
                                            {{ $t('org_pro_union.union')}} <span class="text-danger">*</span>
                                            </template>
                                            <b-form-select
                                            plain
                                            v-model="patient_registration.permanent_union_id"
                                            :options="unionPermaList"
                                            id="permanent_union_id"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            >
                                            <template v-slot:first>
                                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                            </template>
                                            </b-form-select>
                                            <div class="invalid-feedback">
                                            {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="3" sm="3" v-if="patient_registration.permanent_area_type_id === 1">
                                    <ValidationProvider name="City Corporation" vid="permanent_city_corporation_id">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="12"
                                            label-for="permanent_city_corporation_id"
                                            slot-scope="{ valid, errors }"
                                            >
                                            <template v-slot:label>
                                                {{ $t('org_pro.city_corporation') }} <span class="text-danger">*</span>
                                            </template>
                                            <b-form-select
                                            plain
                                            v-model="patient_registration.permanent_city_corporation_id"
                                            :options="cityCorporationPermaList"
                                            id="permanent_city_corporation_id"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            >
                                            <template v-slot:first>
                                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                            </template>
                                            </b-form-select>
                                            <div class="invalid-feedback">
                                            {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="3" sm="3" v-if="patient_registration.permanent_area_type_id === 2">
                                    <ValidationProvider name="Municipality" vid="permanent_pauroshoba_id">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="12"
                                            label-for="permanent_pauroshoba_id"
                                            slot-scope="{ valid, errors }"
                                            >
                                            <template v-slot:label>
                                                {{ $t('org_pro.pauroshoba') }} <span class="text-danger">*</span>
                                            </template>
                                            <b-form-select
                                            plain
                                            v-model="patient_registration.permanent_pauroshoba_id"
                                            :options="pauroshobaPermaList"
                                            id="permanent_pauroshoba_id"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            >
                                            <template v-slot:first>
                                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                            </template>
                                            </b-form-select>
                                            <div class="invalid-feedback">
                                            {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="3" sm="3" v-if="patient_registration.permanent_area_type_id > 0">
                                    <ValidationProvider name="Ward" vid="permanent_ward_id">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="12"
                                            label-for="permanent_ward_id"
                                            slot-scope="{ valid, errors }"
                                            >
                                            <template v-slot:label>
                                                {{ $t('org_pro.ward') }}
                                            </template>
                                            <b-form-select
                                            plain
                                            v-model="patient_registration.permanent_ward_id"
                                            :options="wardPermaList"
                                            id="permanent_ward_id"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            >
                                            <template v-slot:first>
                                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                            </template>
                                            </b-form-select>
                                            <div class="invalid-feedback">
                                            {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                            </b-row>
                            <b-row>
                              <b-col lg="6" sm="6">
                              <ValidationProvider name="Address (Bn)" vid="permanent_address_bn" rules="required">
                                <b-form-group
                                  class="row"
                                  label-cols-sm="12"
                                  label-for="permanent_address_bn"
                                  slot-scope="{ valid, errors }"
                                  >
                                  <template v-slot:label>
                                    {{ $t('hospital_information.address_bn')}} <span class="text-danger">*</span>
                                  </template>
                                  <b-form-textarea
                                    id="permanent_address_bn"
                                    v-model="patient_registration.permanent_address_bn"
                                    rows = "4"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-textarea>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                </b-form-group>
                              </ValidationProvider>
                              </b-col>
                              <b-col lg="6" sm="6">
                              <ValidationProvider name="Address" vid="permanent_address" rules="required">
                                <b-form-group
                                  class="row"
                                  label-cols-sm="12"
                                  label-for="permanent_address"
                                  slot-scope="{ valid, errors }"
                                  >
                                  <template v-slot:label>
                                    {{ $t('hospital_information.address_en')}} <span class="text-danger">*</span>
                                  </template>
                                  <b-form-textarea
                                    id="permanent_address"
                                    v-model="patient_registration.permanent_address"
                                    rows = "4"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-textarea>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                </b-form-group>
                              </ValidationProvider>
                              </b-col>
                            </b-row>
                          </b-container>
                          </div>
                      </iq-card>
                      <br>
                      <div style="font-size:16px; margin-bottom: 6px;" class="bg-gray">
                          <h5 class="text-dark text-center"> {{ $t('externalUser.patient_info') }}</h5>
                      </div>
                      <b-row>
                      <b-col lg="3" sm="3">
                      <ValidationProvider name="Admission Type" vid="admission_type" rules="required|min_value:1">
                        <b-form-group
                          class="row"
                          label-cols-sm="12"
                          label-for="admission_type"
                          slot-scope="{ valid, errors }"
                          >
                          <template v-slot:label>
                            {{ $t('hospital_information.patient_admission_types')}} <span class="text-danger">*</span>
                          </template>
                          <b-form-select
                            plain
                            v-model="patient_registration.admission_type"
                            id="admission_type_id"
                            :options="admissionTypeList"
                            :state="errors[0] ? false : (valid ? true : null)"
                          >
                          <template v-slot:first>
                              <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                          </template>
                          </b-form-select>
                          <div class="invalid-feedback">
                            {{ errors[0] }}
                          </div>
                        </b-form-group>
                      </ValidationProvider>
                      </b-col>
                      <b-col lg="3" sm="3">
                              <ValidationProvider name="Hospital Reg No" vid="hos_reg_no" rules="required">
                                <b-form-group
                                  class="row"
                                  label-cols-sm="12"
                                  label-for="hospital_reg_no"
                                  slot-scope="{ valid, errors }"
                                  >
                                    <template v-slot:label>
                                      <span v-if="patient_registration.admission_type === 1">{{ $t('externalUser.form_reg_num')}}</span>
                                      <span v-else-if="patient_registration.admission_type === 2">{{ $t('externalUser.ticket_reg')}}</span>
                                      <span v-else>{{ $t('hospital_information.hospital_reg_no')}}</span>
                                      <span class="text-danger">*</span>
                                    </template>
                                  <b-form-input
                                    id="hospital_reg_no"
                                    v-model="patient_registration.hos_reg_no"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-input>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                </b-form-group>
                              </ValidationProvider>
                        </b-col>
                        <b-col lg="3" sm="3">
                        <ValidationProvider name="Hospital Reg Date" vid="hos_reg_date" rules="required">
                          <b-form-group
                            class="row"
                            label-cols-sm="12"
                            label-for="hos_reg_date"
                            slot-scope="{ valid, errors }"
                            >
                            <template v-slot:label>
                              <span v-if="patient_registration.admission_type === 2">{{ $t('externalUser.ticket_date')}}</span>
                              <span v-else>{{ $t('hospital_information.hospital_reg_date')}}</span>
                              <span class="text-danger">*</span>
                            </template>
                            <b-form-input
                              id="hos_reg_date"
                              v-model="patient_registration.hos_reg_date"
                              :state="errors[0] ? false : (valid ? true : null)"
                              ></b-form-input>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </b-form-group>
                        </ValidationProvider>
                        </b-col>
                      <b-col lg="3" sm="3">
                        <ValidationProvider name="Department" vid="department"  :rules="`${patient_registration.admission_type === 1 ? 'required|min_value:-1' : ''}`">
                          <b-form-group
                            class="row"
                            label-cols-sm="12"
                            label-for="department"
                            slot-scope="{ valid, errors }"
                            >
                            <template v-slot:label>
                              <span v-if="patient_registration.admission_type === 1">{{ $t('externalUser.admission_dept')}}</span>
                              <span v-else-if="patient_registration.admission_type === 2">{{ $t('externalUser.outdoor_dept')}}</span>
                              <span v-else>{{ $t('hospital_information.dept')}}</span>
                            </template>
                            <b-form-select
                              plain
                              v-model="patient_registration.department_id"
                              id="department_id"
                              :options="departmentList"
                              :state="errors[0] ? false : (valid ? true : null)"
                            >
                            <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                <b-form-select-option :value="-1">{{$t('globalTrans.other')}}</b-form-select-option>
                            </template>
                            </b-form-select>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </b-form-group>
                        </ValidationProvider>
                        </b-col>
                        <b-col lg="3" sm="3" v-if="patient_registration.department_id === -1">
                        <ValidationProvider name="Bed No" vid="departmnet_other" rules="required">
                          <b-form-group
                            class="row"
                            label-cols-sm="12"
                            label-for="departmnet_other"
                            slot-scope="{ valid, errors }"
                            >
                            <template v-slot:label>
                              {{ $t('hospital_information.departmnet_other')}}
                            </template>
                            <b-form-input
                              id="hos_bed"
                              v-model="patient_registration.departmnet_other"
                              :state="errors[0] ? false : (valid ? true : null)"
                            ></b-form-input>
                            <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                          <div class="invalid-feedback">
                            {{ errors[0] }}
                          </div>
                        </b-form-group>
                      </ValidationProvider>
                      </b-col>
                        <b-col lg="3" sm="3" v-if="patient_registration.admission_type === 1">
                        <ValidationProvider name="Bed No" vid="ward_other">
                          <b-form-group
                            class="row"
                            label-cols-sm="12"
                            label-for="ward_other"
                            slot-scope="{ valid, errors }"
                            >
                            <template v-slot:label>
                              {{ $t('hospital_information.ward')}}
                            </template>
                            <b-form-input
                              id="hos_bed"
                              v-model="patient_registration.ward_other"
                              :state="errors[0] ? false : (valid ? true : null)"
                            ></b-form-input>
                            <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                          <div class="invalid-feedback">
                            {{ errors[0] }}
                          </div>
                        </b-form-group>
                      </ValidationProvider>
                      </b-col>
                      <b-col lg="3" sm="3" v-if="patient_registration.admission_type === 1">
                        <ValidationProvider name="Bed No" vid="hos_bed_details" >
                          <b-form-group
                            class="row"
                            label-cols-sm="12"
                            label-for="hos_bed_details"
                            slot-scope="{ valid, errors }"
                            >
                            <template v-slot:label>
                              {{ $t('hospital_information.bed_no')}}
                            </template>
                            <b-form-input
                              id="hos_bed"
                              v-model="patient_registration.hos_bed_details"
                              :state="errors[0] ? false : (valid ? true : null)"
                            ></b-form-input>
                            <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                          <div class="invalid-feedback">
                            {{ errors[0] }}
                          </div>
                        </b-form-group>
                      </ValidationProvider>
                      </b-col>
                    </b-row>
                    <hr>
                    <br>
                <b-row v-if="$store.state.Auth.isLoggedIn">
                  <b-col lg="3" sm="3">
                  <ValidationProvider name="Doctor In Charge (En)" vid="doctor_name_en" rules="required">
                    <b-form-group
                      class="row"
                      label-cols-sm="12"
                      label-for="doctor_name"
                      slot-scope="{ valid, errors }"
                      >
                      <template v-slot:label>
                        {{ $t('hospital_information.doctor_in_charge_en')}} <span class="text-danger">*</span>
                      </template>
                      <b-form-input
                        id="doctor_name"
                        v-model="patient_registration.doctor_name"
                        :state="errors[0] ? false : (valid ? true : null)"
                        ></b-form-input>
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                  </b-col>
                  <b-col lg="3" sm="3">
                  <ValidationProvider name="Doctor In Charge (Bn)" vid="doctor_name_bn" rules="required">
                    <b-form-group
                      class="row"
                      label-cols-sm="12"
                      label-for="doctor_name_bn"
                      slot-scope="{ valid, errors }"
                      >
                      <template v-slot:label>
                        {{ $t('hospital_information.doctor_in_charge_bn')}} <span class="text-danger">*</span>
                      </template>
                      <b-form-input
                        id="doctor_name_bn"
                        v-model="patient_registration.doctor_name_bn"
                        :state="errors[0] ? false : (valid ? true : null)"
                        ></b-form-input>
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                  </b-col>
                  <b-col lg="3" sm="3">
                      <ValidationProvider name="Disease Name (En)" vid="doctor_name" rules="required">
                      <b-form-group
                          class="row"
                          label-cols-sm="12"
                          label-for="patient_situation"
                          slot-scope="{ valid, errors }"
                          >
                          <template v-slot:label>
                          {{ $t('hospital_information.disease_name_en')}} <span class="text-danger">*</span>
                          </template>
                          <b-form-input
                          id="patient_situation"
                          v-model="patient_registration.patient_situation"
                          :state="errors[0] ? false : (valid ? true : null)"
                          ></b-form-input>
                          <div class="invalid-feedback">
                          {{ errors[0] }}
                          </div>
                      </b-form-group>
                      </ValidationProvider>
                    </b-col>
                    <b-col lg="3" sm="3">
                        <ValidationProvider name="Disease Name (Bn)" vid="patient_situation_bn" rules="required">
                        <b-form-group
                            class="row"
                            label-cols-sm="12"
                            label-for="patient_situation_bn"
                            slot-scope="{ valid, errors }"
                            >
                            <template v-slot:label>
                            {{ $t('hospital_information.disease_name_bn')}} <span class="text-danger">*</span>
                            </template>
                            <b-form-input
                            id="disease_name_bn"
                            v-model="patient_registration.patient_situation_bn"
                            :state="errors[0] ? false : (valid ? true : null)"
                            ></b-form-input>
                            <div class="invalid-feedback">
                            {{ errors[0] }}
                            </div>
                        </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col lg="3" sm="3">
                        <ValidationProvider name="Social Officer Comment (En)" vid="so_officer_comment">
                        <b-form-group
                            class="row"
                            label-cols-sm="12"
                            label-for="so_officer_comment_en"
                            slot-scope="{ valid, errors }"
                            >
                            <template v-slot:label>
                            {{ $t('hospital_information.officer_comment_en')}}
                            </template>
                            <b-form-input
                            id="so_officer_comment"
                            v-model="patient_registration.so_officer_comment"
                            :state="errors[0] ? false : (valid ? true : null)"
                            ></b-form-input>
                            <div class="invalid-feedback">
                            {{ errors[0] }}
                            </div>
                        </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col lg="3" sm="3">
                        <ValidationProvider name="Social Officer Comment (Bn)" vid="so_officer_comment">
                        <b-form-group
                            class="row"
                            label-cols-sm="12"
                            label-for="so_officer_comment_bn"
                            slot-scope="{ valid, errors }"
                            >
                            <template v-slot:label>
                            {{ $t('hospital_information.officer_comment_bn')}}
                            </template>
                            <b-form-input
                            id="disease_name_bn"
                            v-model="patient_registration.so_officer_comment_bn"
                            :state="errors[0] ? false : (valid ? true : null)"
                            ></b-form-input>
                            <div class="invalid-feedback">
                            {{ errors[0] }}
                            </div>
                        </b-form-group>
                        </ValidationProvider>
                    </b-col>
                </b-row>
                <template>
                    <div style="font-size:16px;" class="bg-primary">
                        <h5 class="text-white text-center"> {{ $t('externalUser.documents') }}
                        </h5>
                    </div>
                </template>
                <div style="font-size:16px;" class="bg-gray">
                        <h5 class="text-dark text-center"> {{ $t('hospital_information.patient_required_services') }}</h5>
                    </div>
                <br>
                <b-row class="mt-4" v-for="(document,index) in documents" :key="index">
                          <b-col sm="12" lg="5">
                              <ValidationProvider name="Sub Service Type " :vid="`subServiceTypeList${index}`" rules="required|min_value:1">
                                        <b-form-group
                                      class="row"
                                      label-cols-sm="12"
                                      :label-for="`subServiceTypeList${index}`"
                                      slot-scope="{ valid, errors }"
                                  >
                                      <template v-slot:label>
                                          {{ $t('hospital_information.sub_service_type')}} <span v-if="isAdd" class="text-danger">*</span>
                                          {{ $t('externalUser.sub_service_type_x')}}
                                      </template>
                                        <b-form-select
                                            plain
                                            v-model="document.sub_service_type_id"
                                            :options="subServiceTypeList"
                                            :id="`subServiceTypeList${index}`"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            >
                                        <template v-slot:first>
                                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                        </template>
                                        </b-form-select>
                                        <div class="invalid-feedback">
                                        {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                    </ValidationProvider>
                          </b-col>
                          <b-col sm="12" lg="5" v-if="document.sub_service_type_id === 8">
                              <ValidationProvider name="Comments (Bn)" :vid="`description${index}`" :rules="document.sub_service_type_id === 8 ? 'required|max:100' : 'max:100'">
                                  <b-form-group
                                      class="row"
                                      label-cols-sm="12"
                                      :label-for="`description${index}`"
                                      slot-scope="{ valid, errors }"
                                  >
                                      <template v-slot:label>
                                          {{$t('globalTrans.description')}} <span v-if="document.sub_service_type_id === 8" class="text-danger">*</span>
                                      </template>
                                      <b-form-textarea
                                          class="form-control"
                                          v-model="document.description"
                                          :id="`description${index}`"
                                          :state="errors[0] ? false : (valid ? true : null)"
                                      ></b-form-textarea>
                                      <div class="invalid-feedback">
                                          {{ errors[0] }}
                                      </div>
                                  </b-form-group>
                              </ValidationProvider>
                          </b-col>
                          <b-col  sm="12" lg="5">
                              <ValidationProvider name="Upload" :vid="`attachment${index}`" :rules="isAdd?'required':''">
                                  <b-form-group
                                      class="row"
                                      label-cols-sm="12"
                                      :label-for="`attachment${index}`"
                                      slot-scope="{ valid, errors }"
                                  >
                                      <template v-slot:label>
                                          {{ $t('externalUser.uploads')}} <span v-if="isAdd" class="text-danger">*</span>
                                      </template>
                                      <b-form-file
                                          :id="`attachment${index}`"
                                          v-model="document.attachment"
                                          v-on:change="onChange($event, index)"
                                          :state="errors[0] ? false : (valid ? true : null)"
                                      >
                                      </b-form-file>
                                      <div class="invalid-feedback">
                                          {{ errors[0] }}
                                      </div>
                                  </b-form-group>
                              </ValidationProvider>
                          </b-col>
                          <b-col  sm="12" lg="2">
                          <br>
                              <b-button :title="$t('globalTrans.add')" id="button-5" v-if="showAdd(index)" @click="addDocument" variant="primary" class="mr-2"><i style="margin-right: 0" class="ri-add-line"></i></b-button>
                              <b-button :title="$t('globalTrans.delete')" id="button-5" v-if="showTrash(index)" @click="deleteDocument(index)" variant="danger" class="mr-2" ><i style="margin-right: 0" class="ri-delete-bin-line"></i></b-button>
                          </b-col>
                      </b-row>
                <br>
                <template>
                    <b v-if="$route.path.includes('portal')" class="text-dark"><h6 class="text-dark">
                    <br>
                    {{ $n(1) }}. {{ $t('hospital_information.patient_required_services_msg') }}<br>
                    {{ $n(2) }}. {{ $t('hospital_information.patient_required_services_msg_two') }}<br>
                    {{ $n(3) }}. {{ $t('hospital_information.patient_required_services_msg_three') }}
                    </h6></b>
                    <b v-if="!($route.path.includes('portal'))" class="text-dark"><h6 class="text-dark">
                    <br>
                    {{ $n(1) }}. {{ $t('hospital_information.admin_msg') }}<br>
                    </h6></b>
                </template>
                <br>
                <b-row>
                  <b-col>
                    <div class="row">
                      <div class="col-sm-3"></div>
                      <div class="col text-right">
                        <b-button type="submit" variant="primary" class="mr-2">{{ saveBtnName }}</b-button>
                        &nbsp;
                        <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-4')">
                            <router-link :class="'text-light'" :to="{ path: '/portal/hospital-service-panel'}" size="sm">
                              {{ $t('globalTrans.cancel') }}
                            </router-link>
                          </b-button>
                      </div>
                    </div>
                  </b-col>
                </b-row>
                </b-form>
              </ValidationObserver>
                </b-col>
              </b-row>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </iq-card>
  </b-container>
</template>
<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { hospitalServiceBaseUrl, authServiceBaseUrl } from '@/config/api_config'
import { nidApi, portalHosPatientRegistrationStoreApi, portalHospitalApi, portalHospitalDepartmentApi, portalHospitalWardApi, portalHospitalBedApi, patientNewFormNoApi, patientDetailsApi, patientDeleteAcknowledgementApi, patientDeleteExperimentationsApi } from '../../api/routes'
import flatpickr from 'flatpickr'
import Custom from '../../../../../../store/custom'
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  components: {
    ValidationObserver,
    ValidationProvider
  },
  created () {
        this.callHospitalList()
        this.callHospitalDepartmentList()
        this.callHospitalWardList()
        this.callHospitalbedList()
        this.getFormNo()
        this.addDocument()
  },
  mounted () {
    flatpickr('#hos_reg_date', {})
  },
  data () {
    return {
      patTypeText: '',
      nid_verify_check: 1,
      nidButtonDisabled: false,
      request_number: 1,
          documents: [],
          docs: [],
          hospitalServiceBaseUrl,
          isAdd: true,
      selected: '',
      ItemShow: false,
      DhownloadShow: false,
      CityCorpItemShow: false,
      PauroshobaItemShow: false,
      UnionItemShow: false,
      saveBtnName: this.$route.query.id ? this.$t('globalTrans.update') : this.$t('globalTrans.submit'),
      patient_registration: {
        nid_or_brs: 1,
        hos_area_type_id: 0,
        hos_division_id: 0,
        hos_district_id: 0,
        hos_upazila_id: 0,
        hos_city_corporation_id: 0,
        // hospital_id: 0,
        mob_no_type: 1,
        pat_type: 0,
        area_type_id: 0,
        city_corporation_id: 0,
        pauroshoba_id: 0,
        hos_ward_id: 0,
        // hos_bed_id: 0,
        hos_bed_details: '',
        country_id: 1,
        division_id: 0,
        district_id: 0,
        upazilla_id: 0,
        thana_id: 0,
        nid: '',
        union_id: 0,
          permanent_area_type_id: 0,
          permanent_division_id: 0,
          permanent_district_id: 0,
          permanent_upazilla_id: 0,
          permanent_union_id: 0,
          permanent_city_corporation_id: 0,
          permanent_pauroshoba_id: 0,
          permanent_ward_id: 0,
          permanent_address: '',
          permanent_address_bn: '',
        form_no: '',
        hospital_id: '',
        reg_date: this.currentDate(),
        patient_name: '',
        patient_name_bn: '',
        phone_no: '',
        age: 1,
        gender_id: 0,
        occupation_id: 0,
        occupation: '',
        occupation_bn: '',
        monthly_income: '',
        hos_reg_no: '',
        hos_reg_date: '',
        admission_type: 0,
        department_id: 0,
        department: '',
        department_bn: '',
        ward: '',
        ward_id: 0,
        is_freedom_figter: 2,
        is_disable: 2,
        is_underprivileged: 2,
        is_lost_person: 2,
        bed_no: '',
        father_name: '',
        father_name_bn: '',
        mother_name: '',
        mother_name_bn: '',
        guardian_name: '',
        guardian_name_bn: '',
        guardian_mobile_no: '',
        address: '',
        address_bn: '',
        doctor_name: '',
        doctor_name_bn: '',
        patient_situation: '',
        patient_situation_bn: '',
        so_officer_comment: '',
        so_officer_comment_bn: '',
        attachment: '',
        patient_experimentation: [
          {
            sub_service_type_id: 0,
            description: '',
            attachmentq: [],
            experimentation: '',
            experimentation_bn: '',
            others_en: '',
            others_bn: ''
          }
        ],
        patient_acknowledgement: []

      },
      attachment_two: '',
      unitLoad: false,
      districtList: [],
      upazilaList: [],
      unionList: [],
      cityCorporationList: [],
      pauroshobaList: [],
      thanaList: [],
      wardList: [],
      wardPermaList: [],
      departmentList: [],
      hostWardList: [],
      hospitalList: [],
      hospitalDepartmentListArr: [],
      hospitalWardListArr: [],
      hospitalBedListArr: [],
      hospitalIds: [],
      userId: 0,
      sameCheck: 0,
      sameCheckVal: 0,
      bedList: [],
      hospitalListArr: [],
      hosHospitalList: [],
      nidBrsList: [
          { value: 1, text_en: 'National Identity Card', text_bn: 'জাতীয় পরিচয়পত্র' },
          { value: 2, text_en: 'Birth Registration', text_bn: 'জন্ম নিবন্ধনপত্র' }
      ],
      subServiceTypeListX: [
          {
              value: 1,
              text_en: 'Medicine',
              text_bn: 'ঔষধ'
          },
          {
              value: 2,
              text_en: 'Medical Test',
              text_bn: 'পরীক্ষা-নিরীক্ষা'
          },
          {
              value: 3,
              text_en: 'Clothing And Other',
              text_bn: 'বস্ত্র'
          },
          {
              value: 4,
              text_en: 'Blood',
              text_bn: 'রক্ত'
          },
          {
              value: 5,
              text_en: 'Glass',
              text_bn: 'চশমা'
          },
          {
              value: 6,
              text_en: 'Food',
              text_bn: 'পথ্য'
          },
          {
              value: 7,
              text_en: 'Dialysis',
              text_bn: 'ডায়ালাইজার'
          },
          {
              value: 9,
              text_en: 'Fares for transportation',
              text_bn: 'যাতায়াত ভাড়া'
          },
          {
              value: 10,
              text_en: 'Transportation of corpses/ Funeral etc',
              text_bn: 'লাশ পরিবহন/ মৃতের সৎকার ইত্যাদি'
          },
          {
              value: 11,
              text_en: 'Wheelchair',
              text_bn: 'হুইল চেয়ার'
          },
          {
              value: 12,
              text_en: 'Artificial Arms',
              text_bn: 'কৃত্রিম অঙ্গ'
          },
          {
              value: 13,
              text_en: 'Therapy',
              text_bn: 'থেরাপি'
          },
          {
              value: 8,
              text_en: 'Other (If any other service required write in description)',
              text_bn: 'অন্যান্য (অন্য কোন সেবা থাকলে বিবরণে লিখুন)'
          }
      ],
      patient_acknowledgement:
      {
        amount: '',
        attachment: '',
        detail: '',
        detail_bn: ''
      }
    }
  },
  computed: {
    loading () {
      return this.$store.state.commonObj.loading
    },
    ...mapGetters({
            authUser: 'Auth/authUser'
    }),
    getNidBrsList: function () {
      return this.nidBrsList.map(Obj => {
        return { value: Obj.value, text: this.$i18n.locale === 'bn' ? Obj.text_bn : Obj.text_en }
      })
    },
    subOccupationLists: function () {
      return this.$store.state.ExternalUser.commonObj.subOccupationList
    },
    subOccupationList: function () {
      const objectData = this.$store.state.ExternalUser.commonObj.subOccupationList
      return objectData.map((obj, key) => {
        if (this.$i18n.locale === 'bn') {
          return { value: obj.value, text: obj.text_bn }
        } else {
          return { value: obj.value, text: obj.text_en }
        }
      })
    },
    subServiceTypeList: function () {
      // const objectData = this.$store.state.HospitalDisabilityService.commonObj.subServiceTypeList
      const objectData = this.subServiceTypeListX
      return objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
    },
    districtPermaList: function () {
        return this.$store.state.ExternalUser.commonObj.districtList.filter(item => item.status === 0 && item.division_id === this.patient_registration.permanent_division_id)
    },
    cityCorporationPermaList: function () {
        return this.$store.state.ExternalUser.commonObj.cityCorporationList.filter(item => item.status === 0 && item.district_id === this.patient_registration.permanent_district_id)
    },
    unionPermaList: function () {
        return this.$store.state.ExternalUser.commonObj.unionList.filter(item => item.status === 0 && item.upazilla_id === this.patient_registration.permanent_upazilla_id)
    },
    pauroshobaPermaList: function () {
        return this.$store.state.ExternalUser.commonObj.pauroshobaList.filter(item => item.status === 0 && item.upazilla_id === this.patient_registration.permanent_upazilla_id)
    },
    upazillaPermaList: function () {
        return this.$store.state.ExternalUser.commonObj.upazilaList.filter(item => item.status === 0 && item.district_id === this.patient_registration.permanent_district_id)
    },
    getHosDivisionList: function () {
        return this.$store.state.ExternalUser.commonObj.divisionList.filter(item => item.status === 0)
    },
    getHosDistrictList: function () {
        return this.$store.state.ExternalUser.commonObj.districtList.filter(item => item.status === 0 && item.division_id === this.patient_registration.hos_division_id)
    },
    getHosCityCorporationList: function () {
        return this.$store.state.ExternalUser.commonObj.cityCorporationList.filter(item => item.status === 0 && item.district_id === this.patient_registration.hos_district_id)
    },
    getHosUpazillaList: function () {
        return this.$store.state.ExternalUser.commonObj.upazilaList.filter(item => item.status === 0 && item.district_id === this.patient_registration.hos_district_id)
    },
    getHosAreaTypeList: function () {
        const objectData = this.$store.state.ExternalUser.commonObj.wardTypeList
        return objectData.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.id, text: obj.name_bn }
            } else {
                return { value: obj.id, text: obj.name }
            }
        })
    },
    currentLocale: function () {
        return this.$i18n.locale
    },
    getAreaTypeList: function () {
        const objectData = Custom.wardTypeList
        return objectData.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.id, text: obj.name_bn }
            } else {
                return { value: obj.id, text: obj.name }
            }
        })
    },
    divisionList: function () {
        return this.$store.state.ExternalUser.commonObj.divisionList.filter(item => item.status === 0)
    },
    genderList: function () {
          const objectData = this.$store.state.ExternalUser.commonObj.genderList
          return objectData.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
              return { value: obj.value, text: obj.text_bn }
            } else {
              return { value: obj.value, text: obj.text_en }
            }
          })
    },
    admissionTypeList: function () {
      const objectData = this.$store.state.HospitalDisabilityService.commonObj.admissionTypeList
            return objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.id, text: obj.name_bn }
                } else {
                    return { value: obj.id, text: obj.name }
                }
            })
    }
  },
  watch: {
    'patient_registration.permanent_area_type_id': function () {
      this.sameAsCheck()
    },
    'patient_registration.area_type_id': function () {
      this.sameAsCheck()
    },
    'patient_registration.permanent_division_id': function () {
      this.sameAsCheck()
    },
    'patient_registration.permanent_district_id': function () {
      this.sameAsCheck()
    },
    'patient_registration.permanent_upazilla_id': function () {
      this.sameAsCheck()
    },
    'patient_registration.permanent_ward_id': function () {
      this.sameAsCheck()
    },
    'patient_registration.ward_id': function () {
      this.sameAsCheck()
    },
    'patient_registration.permanent_address': function () {
      this.sameAsCheck()
    },
    'patient_registration.address': function () {
      this.sameAsCheck()
    },
    'patient_registration.permanent_address_bn': function () {
      this.sameAsCheck()
    },
    'patient_registration.address_bn': function () {
      this.sameAsCheck()
    },
    'patient_registration.hos_area_type_id': function () {
        this.hosHospitalList = this.getHosHospitalList()
    },
    'patient_registration.hos_division_id': function () {
        this.hosHospitalList = this.getHosHospitalList()
    },
    'patient_registration.hos_district_id': function () {
        this.hosHospitalList = this.getHosHospitalList()
    },
    'patient_registration.hos_upazila_id': function () {
        this.hosHospitalList = this.getHosHospitalList()
    },
    'patient_registration.hos_city_corporation_id': function (newVal, oldVal) {
        this.hosHospitalList = this.getHosHospitalList()
        if (newVal !== oldVal) {
          this.patient_registration.hospit_id = ''
        }
    },
    currentLocale: function (newVal, oldVal) {
        this.hosHospitalList = this.getHosHospitalList()
        if (newVal !== oldVal) {
              this.calculateAge()
          }
    },
    'patient_registration.division_id': function (newVal, oldVal) {
        this.districtList = this.getDistrictList(newVal)
        this.sameAsCheck()
    },
    'patient_registration.dob': function (newVal, oldVal) {
        if (newVal !== oldVal) {
            if (parseInt(this.patient_registration.pat_type) === 4) {
            } else {
            this.calculateAge()
            }
        }
    },
    'patient_registration.hospit_id': function () {
      if (this.patient_registration.hospit_id > 0) {
        this.patient_registration.hospital_id = this.patient_registration.hospit_id
        if (this.patient_registration.hospital_id > 0) {
        this.departmentList = this.gethosDeptListByHostital(this.patient_registration.hospital_id)
        }
      }
    },
    'patient_registration.district_id': function (newVal, oldVal) {
        this.cityCorporationList = this.getCityCorporationList(newVal)
        this.upazilaList = this.getUpazilaList(newVal)
        this.thanaList = this.getThanaList(newVal)
        this.sameAsCheck()
    },
    'patient_registration.upazilla_id': function (newVal, oldVal) {
        this.unionList = this.getUnionList(newVal)
        this.pauroshobaList = this.getPauroshobaList(newVal)
        this.sameAsCheck()
    },
    'patient_registration.city_corporation_id': function (newVal, oldVal) {
        this.wardList = this.getWardListByCityCorportaion(newVal)
        this.sameAsCheck()
    },
    'patient_registration.union_id': function (newVal, oldVal) {
        this.wardList = this.getWardListByUnion(newVal)
        this.sameAsCheck()
    },
    'patient_registration.pauroshoba_id': function (newVal, oldVal) {
        this.wardList = this.getWardListByPauroshoba(newVal)
        this.sameAsCheck()
    },
      'patient_registration.permanent_city_corporation_id': function (newVal, oldVal) {
          this.wardPermaList = this.getPermaWardListByCityCorportaion(newVal)
          this.sameAsCheck()
      },
      'patient_registration.permanent_union_id': function (newVal, oldVal) {
          this.wardPermaList = this.getPermaWardListByUnion(newVal)
          this.sameAsCheck()
      },
      'patient_registration.permanent_pauroshoba_id': function (newVal, oldVal) {
          this.wardPermaList = this.getPermaWardListByPauroshoba(newVal)
          this.sameAsCheck()
      },
      'patient_registration.department_id': function (newVal, oldVal) {
        if (newVal && oldVal !== 0) {
            this.patient_registration.hos_ward_id = 0
            // this.patient_registration.hos_bed_id = 0
          }
          this.hostWardList = this.gethosWardListByDepartment(newVal)
      }
  },
  methods: {
    myFilter: (option, text, search) => {
      const temp = search.toLowerCase()
      return option.text_en.toLowerCase().indexOf(temp) > -1 ||
      option.text_bn.toLowerCase().indexOf(temp) > -1
    },
    calculateAge () {
          const birthDate = this.patient_registration.dob
          var starts = moment(birthDate)
          var ends = moment()
          var duration = moment.duration(ends.diff(starts))
          let newAge = ''
          if (this.$i18n.locale === 'bn') {
              newAge = this.$n(duration._data.years) + ' বছর, ' + this.$n(duration._data.months) + ' মাস, ' + this.$n(duration._data.days) + ' দিন'
          } else {
              const yearText = duration._data.years > 1 ? ' Years, ' : ' Year, '
              const monthText = duration._data.months > 1 ? ' Months, ' : ' Month, '
              const dayText = duration._data.days > 1 ? ' Days' : ' Day'
              newAge = this.$n(duration._data.years) + yearText + this.$n(duration._data.months) + monthText + this.$n(duration._data.days) + dayText
          }
          this.calculate_age = newAge
          this.patient_registration.age = duration._data.years
        },
        async nidVerify () {
          this.unitLoad = true
          const requestData = {
            component_id: 4,
            module_id: 0,
            service_id: 0,
            menu_id: 0,
            date_of_birth: this.patient_registration.dob,
            nid: this.patient_registration.nid,
            request_number: this.request_number
          }
          let result = null
          result = await RestApi.postData(authServiceBaseUrl, nidApi, requestData)
          if (result.success) {
              const data = result.data
              this.nid_verify_check = 2
              this.patient_registration.patient_name_bn = data.name
              this.patient_registration.patient_name = data.nameEn
              if (result.ourDB) {
                  this.request_number = 2
              }
              if (!result.ourDB) {
                  this.nidButtonDisabled = true
              }
              this.patient_registration.father_name_bn = 'N/A'
              this.patient_registration.mother_name_bn = 'N/A'
              this.unitLoad = false
          } else {
            this.nid_verify_check = 1
            this.patient_registration.patient_name_bn = ''
            this.patient_registration.patient_name = ''
            this.patient_registration.father_name_bn = ''
            this.patient_registration.mother_name_bn = ''
            this.$toast.error({
              title: this.$t('globalTrans.error'),
              message: this.$t('globalTrans.nid_error'),
              color: '#D6E09B'
            })
            this.unitLoad = false
          }
        },
        checkDoc () {
            this.isAdd = true
        },
        deleteEditDocument (data) {
            this.docs = this.docs.filter(document => document.id !== data.id)
        },
        showTrash (index) {
            const length = this.documents.length
            if (length === 1) {
                return false
            }
            return true
        },
        onChange (event, index) {
            const input = event.target
            if (input.files && input.files[0]) {
                const reader = new FileReader()
                reader.onload = (e) => {
                    this.documents[index].file = e.target.result
                }
                reader.readAsDataURL(input.files[0])
            } else {
                this.documents[index].file = ''
            }
        },
        showAdd (index) {
            const length = this.documents.length
            if (index === length - 1) {
                return true
            }
            return false
        },
        addDocument () {
            const obj = { sub_service_type_id: 0, attachment: [], comment: '', description: '' }
            this.documents.push(obj)
        },
        deleteDocument (i) {
            this.documents = this.documents.filter((_, index) => index !== i)
        },
    sameAs () {
      if (parseInt(this.sameCheckVal) === 1) {
      this.patient_registration.permanent_area_type_id = this.patient_registration.area_type_id
      this.patient_registration.permanent_division_id = this.patient_registration.division_id
      this.patient_registration.permanent_district_id = this.patient_registration.district_id
      this.patient_registration.permanent_upazilla_id = this.patient_registration.upazilla_id
      this.patient_registration.permanent_union_id = this.patient_registration.union_id
      this.patient_registration.permanent_city_corporation_id = this.patient_registration.city_corporation_id
      this.patient_registration.permanent_pauroshoba_id = this.patient_registration.pauroshoba_id
      this.patient_registration.permanent_ward_id = this.patient_registration.ward_id
      this.patient_registration.permanent_address = this.patient_registration.address
      this.patient_registration.permanent_address_bn = this.patient_registration.address_bn
      }
    },
    async sameAsCheck () {
      if (this.patient_registration.permanent_area_type_id === this.patient_registration.area_type_id && this.patient_registration.permanent_division_id === this.patient_registration.division_id && this.patient_registration.permanent_district_id === this.patient_registration.district_id && this.patient_registration.permanent_upazilla_id === this.patient_registration.upazilla_id && this.patient_registration.permanent_union_id === this.patient_registration.union_id && this.patient_registration.permanent_city_corporation_id === this.patient_registration.city_corporation_id && this.patient_registration.permanent_pauroshoba_id === this.patient_registration.pauroshoba_id && this.patient_registration.permanent_ward_id === this.patient_registration.ward_id && this.patient_registration.permanent_address === this.patient_registration.address && this.patient_registration.permanent_address_bn === this.patient_registration.address_bn) {
        this.sameCheckVal = 1
      } else {
        this.sameCheckVal = 0
      }
    },
    async callHospitalList () {
        const result = await RestApi.getData(hospitalServiceBaseUrl, portalHospitalApi)
        if (result.success) {
                this.hospitalListArr = result.data
        } else {
                this.hospitalListArr = []
        }
    },
    async callHospitalDepartmentList () {
        const result = await RestApi.getData(hospitalServiceBaseUrl, portalHospitalDepartmentApi)
        if (result.success) {
                this.hospitalDepartmentListArr = result.data
        } else {
                this.hospitalDepartmentListArr = []
        }
    },
    async callHospitalWardList () {
        const result = await RestApi.getData(hospitalServiceBaseUrl, portalHospitalWardApi)
        if (result.success) {
                this.hospitalWardListArr = result.data
        } else {
                this.hospitalWardListArr = []
        }
    },
    async callHospitalbedList () {
        const result = await RestApi.getData(hospitalServiceBaseUrl, portalHospitalBedApi)
        if (result.success) {
                this.hospitalBedListArr = result.data
        } else {
                this.hospitalBedListArr = []
        }
    },
    getHosHospitalList () {
      if (this.patient_registration.hos_area_type_id === 1) {
        const objectData = this.hospitalListArr.filter(item => item.status === 1 && item.city_corporation_id === parseInt(this.patient_registration.hos_city_corporation_id) && item.area_type_id === parseInt(this.patient_registration.hos_area_type_id)).filter(item => item.status === 1 && item.is_jointly_formated === 0)
        return objectData.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn, text_en: obj.text_en, text_bn: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en, text_en: obj.text_en, text_bn: obj.text_bn }
            }
        })
      } else {
        const objectData = this.hospitalListArr.filter(item => item.status === 1 && item.upazilla_id === parseInt(this.patient_registration.hos_upazila_id) && item.area_type_id === parseInt(this.patient_registration.hos_area_type_id)).filter(item => item.status === 1 && item.is_jointly_formated === 0)
        return objectData.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn, text_en: obj.text_en, text_bn: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en, text_en: obj.text_en, text_bn: obj.text_bn }
            }
        })
      }
    },
    getAreaTypeData (typeId) {
        this.ItemShow = true
        if (typeId === 1) {
            this.CityCorpItemShow = true
            this.PauroshobaItemShow = false
            this.UnionItemShow = false
        } else if (typeId === 2) {
            this.CityCorpItemShow = false
            this.PauroshobaItemShow = true
            this.UnionItemShow = false
        } else if (typeId === 3) {
            this.CityCorpItemShow = false
            this.PauroshobaItemShow = false
            this.UnionItemShow = true
        }
        if (!this.$route.query.id) {
          this.patient_registration.city_corporation_id = 0
          this.patient_registration.pauroshoba_id = 0
          this.patient_registration.ward_id = 0
          this.patient_registration.country_id = 1
          this.patient_registration.division_id = 0
          this.patient_registration.district_id = 0
          this.patient_registration.upazilla_id = 0
          this.patient_registration.thana_id = 0
          this.patient_registration.union_id = 0
        }
    },
    currentDate () {
      const current = new Date()
      const date = `${current.getFullYear()}/${current.getMonth() + 1}/${current.getDate()}`
      return date
    },
    addPatientExperimentation () {
        this.patient_registration.patient_experimentation.push({
        sub_service_type_id: 0,
        description: '',
        attachmentq: [],
        experimentation: '',
        experimentation_bn: ''
      })
    },
    async patientInfoById (id) {
      const result = await RestApi.getData(hospitalServiceBaseUrl, patientDetailsApi + '/' + id)
      if (result.success) {
            this.patient_registration = result.data
            this.patient_registration.hospital_id = result.data.hospital_id
            this.patient_acknowledgement = result.data.patient_acknowledgement
            this.getAreaTypeData(result.data.area_type_id)
      }
    },
    async getFormNo () {
      const result = await RestApi.getData(hospitalServiceBaseUrl, patientNewFormNoApi)
      if (result.success) {
            this.patient_registration.form_no = result.data
      }
    },
    async removeExperimentation (index, id) {
      if (id === null) {
            this.patient_registration.patient_experimentation.splice(index, 1)
        } else {
          const result = await RestApi.deleteData(hospitalServiceBaseUrl, `${patientDeleteExperimentationsApi}/${id}`)
          if (result.success) {
            this.patient_registration.patient_experimentation.splice(index, 1)
          }
        }
    },
    async removeAcknowledgement (index, id) {
      if (id === null) {
            this.patient_registration.patient_acknowledgement.splice(index, 1)
        } else {
          const result = await RestApi.deleteData(hospitalServiceBaseUrl, `${patientDeleteAcknowledgementApi}/${id}`)
          if (result.success) {
            this.patient_registration.patient_acknowledgement.splice(index, 1)
          }
        }
    },
    async register () {
      this.loading = true
      if (this.patient_registration.pat_type === '1') {
         this.patTypeText = this.$t('hospital_information.freedom_figter')
      }
      if (this.patient_registration.pat_type === '2') {
         this.patTypeText = this.$t('hospital_information.disable')
      }
      if (this.patient_registration.pat_type === '3') {
         this.patTypeText = this.$t('hospital_information.underprivileged')
      }
      if (this.patient_registration.pat_type === '4') {
         this.patTypeText = this.$t('hospital_information.lost_person')
      }
      if (this.patient_registration.pat_type === '5') {
         this.patTypeText = this.$t('globalTrans.other')
      }
      const result = await window.vm.$swal({
            html: '<p style="text-align: left !important">' +
            this.$t('org_pro.area_type') + ' : ' + this.getArea(this.patient_registration.hos_area_type_id) + '<br>' + this.$t('externalUser.division') + ' : ' + this.getDivision(this.patient_registration.hos_division_id) + '<br>' + this.$t('org_pro_district.district') + ' : ' + this.getDistrict(this.patient_registration.hos_district_id) + '<br>' + this.$t('org_pro_upazilla.upazilla') + ' : ' + this.getUpazilla(this.patient_registration.hos_upazila_id) + '<br>' + this.$t('org_pro.city_corporation') + ' : ' + this.getCityCorporation(this.patient_registration.hos_city_corporation_id) + '<br>' + this.$t('billing_info.hospital_name') + ' : ' + this.getHospitalName(this.patient_registration.hospital_id) + '<br>' + this.$t('hospital_information.form_no') + ' : ' + this.patient_registration.form_no + '<br>' + this.$t('globalTrans.date') + ' : ' + this.patient_registration.reg_date + '<br>' + this.$t('hospital_information.applicant') + ' : ' + (this.patient_registration.mob_no_type === 1 ? this.$t('hospital_information.patient_self') : this.$t('hospital_information.guardians_care')) + '<br>' + this.$t('externalUser.nidBrs') + ' : ' + this.nidBrsName(this.patient_registration.nid_or_brs) + '<br>' + this.$t('externalUser.nid') + ' : ' + this.patient_registration.nid + '<br>' + this.$t('externalUser.brs_no') + ' : ' + this.patient_registration.brs_no + '<br>' + this.$t('externalUser.dob') + ' : ' + this.patient_registration.dob + '<br>' + this.$t('hospital_information.patient_name_bn') + ' : ' + this.patient_registration.patient_name_bn + '<br>' + this.$t('hospital_information.patient_name_en') + ' : ' + this.patient_registration.patient_name + '<br>' + this.$t('globalTrans.father_name_bn') + ' : ' + this.patient_registration.father_name_bn + '<br>' + this.$t('globalTrans.father_name_en') + ' : ' + this.patient_registration.father_name + '<br>' + this.$t('hospital_information.mother_name_bn') + ' : ' + this.patient_registration.mother_name_bn + '<br>' + this.$t('hospital_information.mother_name_en') + ' : ' + this.patient_registration.mother_name + '<br>' + this.$t('hospital_information.husband_name') + this.$t('hospital_information.bn') + ' : ' + this.patient_registration.husband_name_bn + '<br>' + this.$t('hospital_information.husband_name') + this.$t('hospital_information.en') + ' : ' + this.patient_registration.husband_name_en + '<br>' + this.$t('globalTrans.mob_no') + ' : ' + this.patient_registration.phone_no + '<br>' + this.$t('hospital_information.age') + ' : ' + this.patient_registration.age + '<br>' + this.$t('hospital_information.gender') + ' : ' + this.getGenderName(this.patient_registration.gender_id) + '<br>' + this.$t('globalTrans.occupation') + ' : ' + this.getSubOccupation(this.patient_registration.occupation_id) + '<br>' + this.$t('hospital_information.occupation_bnn') + ' : ' + this.patient_registration.occupation_bn + '<br>' + this.$t('hospital_information.occupation_enn') + ' : ' + this.patient_registration.occupation + '<br>' + this.$t('hospital_information.monthly_income') + ' : ' + this.patient_registration.monthly_income + '<br>' + this.$t('externalUser.patient_type') + ' : ' + this.patTypeText + '<br>' + this.$t('hospital_information.guardian_name_bn') + ' : ' + this.patient_registration.guardian_name_bn + '<br>' + this.$t('hospital_information.guardian_name_en') + ' : ' + this.patient_registration.guardian_name + '<br>' + this.$t('hospital_information.guardian_n') + ' : ' + this.patient_registration.guardian_mobile_no + '<br><b>' + this.$t('externalUser.present_address') + '</b><br>' + this.$t('org_pro.area_type') + ' : ' + this.getArea(this.patient_registration.area_type_id) + '<br>' + this.$t('org_pro_division.division') + ' : ' + this.getDivision(this.patient_registration.division_id) + '<br>' + this.$t('org_pro_district.district') + ' : ' + this.getDistrict(this.patient_registration.district_id) + '<br>' + this.$t('org_pro_upazilla.upazilla') + ' : ' + this.getUpazilla(this.patient_registration.upazilla_id) + '<br>' + this.$t('org_pro_union.union') + ' : ' + this.getUnion(this.patient_registration.union_id) + '<br>' + this.$t('org_pro.city_corporation') + ' : ' + this.getCityCorporation(this.patient_registration.city_corporation_id) + '<br>' + this.$t('org_pro.pauroshoba') + ' : ' + this.getPauroshoba(this.patient_registration.pauroshoba_id) + '<br>' + this.$t('org_pro.ward') + ' : ' + this.getWard(this.patient_registration.ward_id) + '<br>' + this.$t('hospital_information.address_bn') + ' : ' + this.patient_registration.address_bn + '<br>' + this.$t('hospital_information.address_en') + ' : ' + this.patient_registration.address + '<br><b>' + this.$t('externalUser.permanent_address') + '</b><br>' + this.$t('org_pro.area_type') + ' : ' + this.getArea(this.patient_registration.permanent_area_type_id) + '<br>' + this.$t('org_pro_division.division') + ' : ' + this.getDivision(this.patient_registration.permanent_division_id) + '<br>' + this.$t('org_pro_district.district') + ' : ' + this.getDistrict(this.patient_registration.permanent_district_id) + '<br>' + this.$t('org_pro_upazilla.upazilla') + ' : ' + this.getUpazilla(this.patient_registration.permanent_upazilla_id) + '<br>' + this.$t('org_pro_union.union') + ' : ' + this.getUnion(this.patient_registration.permanent_union_id) + '<br>' + this.$t('org_pro.city_corporation') + ' : ' + this.getCityCorporation(this.patient_registration.permanent_city_corporation_id) + '<br>' + this.$t('org_pro.pauroshoba') + ' : ' + this.getPauroshoba(this.patient_registration.permanent_pauroshoba_id) + '<br>' + this.$t('org_pro.ward') + ' : ' + this.getWard(this.patient_registration.permanent_ward_id) + '<br>' + this.$t('hospital_information.address_bn') + ' : ' + this.patient_registration.permanent_address_bn + '<br>' + this.$t('hospital_information.address_en') + ' : ' + this.patient_registration.permanent_address + '<br>' + this.$t('hospital_information.patient_admission_types') + ' : ' + this.getAdmissionTypeName(this.patient_registration.admission_type) + '<br>' + this.$t('hospital_information.hospital_reg_no') + ' : ' + this.patient_registration.hos_reg_no + '<br>' + this.$t('hospital_information.hospital_reg_date') + ' : ' + this.patient_registration.hos_reg_date + '<br>' + '</p>',
            title: window.vm.$t('globalTrans.surePrompt'),
            showCancelButton: true,
            confirmButtonText: window.vm.$t('globalTrans.yes'),
            cancelButtonText: window.vm.$t('globalTrans.no'),
            focusConfirm: false,
            didOpen: (popup) => {
              popup.style.width = '800px'
            }
          })
          if (result.isConfirmed) {
            this.$store.dispatch('mutateCommonProperties', { loading: true })
            let result = null
            const loadingState = { loading: false, listReload: false }
            result = await RestApi.postData(hospitalServiceBaseUrl, portalHosPatientRegistrationStoreApi, { ...this.patient_registration, documents: this.documents })
            loadingState.listReload = true
            this.$store.dispatch('mutateCommonProperties', loadingState)
              if (result.success) {
                this.$store.dispatch('mutateCommonProperties', { hasDropdownLoaded: false, loading: false })
                this.$router.push({ path: '/portal/hospital-service-panel' })
                this.$toast.success({
                  title: this.$t('globalTrans.success'),
                  message: this.$route.query.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
                  color: '#D6E09B'
                })
                this.loading = false
                await window.vm.$swal({
                  title: window.vm.$t('externalUser.health_service_msg'),
                  showCancelButton: false,
                  confirmButtonText: window.vm.$t('globalTrans.thanks'),
                  focusConfirm: false
                })
              } else {
                this.loading = false
                this.$store.dispatch('mutateCommonProperties', { loading: false })
                this.$toast.error({
                  title: 'Error',
                  message: result.message
                })
                this.$refs.form.setErrors(result.errors)
              }
          }
    },
    getCropNameList (cropTypeId = null) {
      const cropList = this.$store.state.warehouse.commodityNameList.filter(document => document.status === 0)
      if (cropTypeId) {
        return cropList.filter(document => document.commodity_group_id === cropTypeId)
      }
      return cropList
    },
    async getPatientInfo (id = null) {
      const result = await RestApi.getData(hospitalServiceBaseUrl, patientDetailsApi + '/' + id)
      if (result.success) {
            this.patient = result.data
      }
    },
    getThanaList (districtId = null) {
      const thanaList = this.$store.state.ExternalUser.commonObj.upazilaList.filter(item => item.status === 0)
      if (districtId) {
          return thanaList.filter(upazila => upazila.district_id === districtId)
      }
      return thanaList
    },
    getDistrictList (divisionId = null) {
        const districtList = this.$store.state.ExternalUser.commonObj.districtList.filter(item => item.status === 0)

        if (divisionId) {
            return districtList.filter(district => district.division_id === divisionId)
        }

        return districtList
    },
    getUpazilaList (districtId = null) {
        const upazilaList = this.$store.state.ExternalUser.commonObj.upazilaList.filter(item => item.status === 0)

        if (districtId) {
            return upazilaList.filter(upazila => upazila.district_id === districtId)
        }

        return upazilaList
    },
    getUnionList (upazilaId = null) {
        const unionList = this.$store.state.ExternalUser.commonObj.unionList.filter(item => item.status === 0)
        if (upazilaId) {
            return unionList.filter(union => union.upazilla_id === upazilaId)
        }

        return unionList
    },
    getCityCorporationList (districtId) {
        const objectData = this.$store.state.ExternalUser.commonObj.cityCorporationList.filter(item => item.status === 0 && item.district_id === districtId)
        return objectData.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
    },
    getPauroshobaList (upazillaId = null) {
        const objectData = this.$store.state.ExternalUser.commonObj.pauroshobaList.filter(item => item.upazilla_id === upazillaId)
        if (upazillaId) {
            return objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
        }
    },
    getWardListByCityCorportaion (cityCorpId) {
        const objectData = this.$store.state.ExternalUser.commonObj.wardList
        const wardObjectList = objectData.filter(item => item.city_corporation_id === cityCorpId && item.status === 0)
        return wardObjectList.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text }
            }
        })
    },
    getWardListByPauroshoba (pauroshobaId) {
        const objectData = this.$store.state.ExternalUser.commonObj.wardList
        const wardObjectList = objectData.filter(item => item.pauroshoba_id === pauroshobaId && item.division_id === this.patient_registration.division_id && item.district_id === this.patient_registration.district_id && item.upazilla_id === this.patient_registration.upazilla_id && item.status === 0)
        return wardObjectList.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text }
            }
        })
    },
    getWardListByUnion (unionId) {
        const objectData = this.$store.state.ExternalUser.commonObj.wardList
        const wardObjectList = objectData.filter(item => item.union_id === unionId && item.division_id === this.patient_registration.division_id && item.district_id === this.patient_registration.district_id && item.upazilla_id === this.patient_registration.upazilla_id && item.status === 0)
        return wardObjectList.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text }
            }
        })
    },
        getPermaWardListByCityCorportaion (cityCorpId) {
            const objectData = this.$store.state.ExternalUser.commonObj.wardList
            const wardObjectList = objectData.filter(item => item.city_corporation_id === cityCorpId && item.status === 0)
            return wardObjectList.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text }
                }
            })
        },
        getPermaWardListByPauroshoba (pauroshobaId) {
            const objectData = this.$store.state.ExternalUser.commonObj.wardList
            const wardObjectList = objectData.filter(item => item.pauroshoba_id === pauroshobaId && item.division_id === this.patient_registration.division_id && item.district_id === this.patient_registration.district_id && item.upazilla_id === this.patient_registration.upazilla_id && item.status === 0)
            return wardObjectList.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text }
                }
            })
        },
        getPermaWardListByUnion (unionId) {
            const objectData = this.$store.state.ExternalUser.commonObj.wardList
            const wardObjectList = objectData.filter(item => item.union_id === unionId && item.division_id === this.patient_registration.division_id && item.district_id === this.patient_registration.district_id && item.upazilla_id === this.patient_registration.upazilla_id && item.status === 0)
            return wardObjectList.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text }
                }
            })
        },
    gethosDeptListByHostital (hosId) {
        const objectData = this.hospitalDepartmentListArr
        if (this.patient_registration.hospital_id !== 0) {
          const deptObjectList = objectData.filter(item => item.hospital_id === parseInt(hosId))
        return deptObjectList.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
        }
    },
    gethosWardListByDepartment (deptId) {
        const objectData = this.hospitalWardListArr
        if (this.patient_registration.hospital_id !== 0) {
          const wardObjectList = objectData.filter(item => item.department_id === deptId && item.hospital_id === this.patient_registration.hospital_id)
        return wardObjectList.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
        }
    },
    getBedListByWard (wardId) {
        const objectData = this.hospitalBedListArr
        const wardObjectList = objectData.filter(item => item.department_id === this.patient_registration.department_id && item.ward_id === wardId && item.isAssigned === 1)
        return wardObjectList.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
    },
    getHospitalName (id) {
      const objectData = this.hospitalListArr.find(item => item.value === parseInt(id))
          if (objectData) {
            if (this.$i18n.locale === 'bn') {
                return objectData.text_bn
            } else {
                return objectData.text_en
            }
          } else {
            return ''
          }
    },
    nidBrsName (id) {
        const objectData = this.nidBrsList.find(item => item.value === parseInt(id))
        if (objectData) {
            if (this.$i18n.locale === 'bn') {
              return objectData.text_bn
            } else {
              return objectData.text_en
            }
        } else {
          return ''
        }
    },
    getArea (id) {
        const objectData = this.$store.state.ExternalUser.commonObj.wardTypeList.find(item => item.id === parseInt(id))
        if (objectData) {
            if (this.$i18n.locale === 'bn') {
              return objectData.name_bn
            } else {
              return objectData.name
            }
        } else {
          return ''
        }
    },
    getBloodGroup (id) {
      const objectData = this.$store.state.ExternalUser.commonObj.bloodGroupList.find(item => item.value === parseInt(id))
      if (objectData) {
            if (this.$i18n.locale === 'bn') {
              return objectData.text_bn
            } else {
              return objectData.text_en
            }
        } else {
          return ''
        }
    },
    getSubOccupation (id) {
      const objectData = this.$store.state.commonObj.subOccupationList.find(item => item.value === parseInt(id))
      if (objectData) {
            if (this.$i18n.locale === 'bn') {
              return objectData.text_bn
            } else {
              return objectData.text_en
            }
        } else {
          return ''
        }
    },
    getDivision (id) {
        const objectData = this.$store.state.ExternalUser.commonObj.divisionList.find(item => item.value === parseInt(id))
        if (objectData) {
            if (this.$i18n.locale === 'bn') {
              return objectData.text_bn
            } else {
              return objectData.text_en
            }
        } else {
          return ''
        }
    },
    getDistrict (id) {
      const objectData = this.$store.state.ExternalUser.commonObj.districtList.find(item => item.value === parseInt(id))
        if (objectData) {
            if (this.$i18n.locale === 'bn') {
              return objectData.text_bn
            } else {
              return objectData.text_en
            }
        } else {
          return ''
        }
    },
    getCityCorporation (id) {
      const objectData = this.$store.state.ExternalUser.commonObj.cityCorporationList.find(item => item.value === parseInt(id))
        if (objectData) {
            if (this.$i18n.locale === 'bn') {
              return objectData.text_bn
            } else {
              return objectData.text_en
            }
        } else {
          return ''
        }
    },
    getUpazilla (id) {
      const objectData = this.$store.state.ExternalUser.commonObj.upazilaList.find(item => item.value === parseInt(id))
        if (objectData) {
            if (this.$i18n.locale === 'bn') {
              return objectData.text_bn
            } else {
              return objectData.text_en
            }
        } else {
          return ''
        }
    },
    getUnion (id) {
      const objectData = this.$store.state.ExternalUser.commonObj.unionList.find(item => item.value === parseInt(id))
        if (objectData) {
            if (this.$i18n.locale === 'bn') {
              return objectData.text_bn
            } else {
              return objectData.text_en
            }
        } else {
          return ''
        }
    },
    getPauroshoba (id) {
      const objectData = this.$store.state.ExternalUser.commonObj.pauroshobaList.find(item => item.value === parseInt(id))
        if (objectData) {
            if (this.$i18n.locale === 'bn') {
              return objectData.text_bn
            } else {
              return objectData.text_en
            }
        } else {
          return ''
        }
    },
    getWard (id) {
      const objectData = this.$store.state.ExternalUser.commonObj.wardList.find(item => item.value === parseInt(id))
        if (objectData) {
            if (this.$i18n.locale === 'bn') {
              return objectData.text_bn
            } else {
              return objectData.text_en
            }
        } else {
          return ''
        }
    },
    getGenderName (id) {
      const objectData = this.$store.state.ExternalUser.commonObj.genderList.find(item => item.value === parseInt(id))
        if (objectData) {
            if (this.$i18n.locale === 'bn') {
              return objectData.text_bn
            } else {
              return objectData.text_en
            }
        } else {
          return ''
        }
    },
    getAdmissionTypeName (id) {
        const objectData = this.$store.state.HospitalDisabilityService.commonObj.admissionTypeList.find(item => item.id === parseInt(id))
          if (objectData) {
              if (this.$i18n.locale === 'bn') {
                return objectData.name_bn
              } else {
                return objectData.name
              }
          } else {
            return ''
          }
      }
  }
}
</script>
<style scoped>
.card-address{
padding: 0px !important;
background-color: rgb(246, 250, 247) !important;
}
.iq-card-header{
  min-height: 30px !important;
  padding-top: 10px !important;
}
.card-address-header{
  max-height: 30px !important;
}

  .list_style {
    list-style-type: square !important
  }
  /* .reduced-expra-margin{
    margin-bottom: -15px;
  } */
  @media only screen and (min-width: 1111px) {
    .reduced-expra-margin{
    margin-bottom: 0px;
  }
  }
  @media only screen and (min-width: 1101px){
    /*  */
  #row-6, #row-7, #row-8{
    margin-bottom: -15px !important;
  }
  }
  @media only screen and (min-width: 1101px) and (max-width: 1664px){
    /*  */
  #row-4{
    margin-bottom: -15px !important;
  }
  }
  @media only screen and (min-width: 1101px) and (max-width: 1757px){
    /*  */
  #row-5{
    margin-bottom: -15px !important;
  }
  }
  @media only screen and (min-width: 768px) and (max-width: 1100px) {
    .reduced-expra-margin{
      margin-bottom: -15px;
    }
  }
  @media only screen and (min-width: 300px) and (max-width: 767px) {
    .reduced-expra-margin{
      margin-bottom: -15px;
    }
  }
</style>
